<style >
@import "./act3.css";
</style>
<style >
@import "../../static/css/news.css";
</style>
<template>	
	<div class="view-main-warp" >
	  <!-- debug -->
	  <div class="debug" v-if='onDebug' v-html="debugInfo"></div>
	  <!-- debug end-->
		<!-- 幻灯片 -->
		<div class="slider-wrap">
	 		<img class="index-logo" src="static/img/index/logo.png" />
	 		<img class="index-search" src="static/img/index/index-search-v2.png" @click="displaySearch()"/> 
	      <!-- 配置slider组件 -->
        <slider ref="slider" :options="sliderOptions" @slide='slide' @init='onInit'>
          
          <!-- 直接使用slideritem slot -->
        <!--   <slideritem >
           <act-10-banenr></act-10-banenr>
         </slideritem>
         -->
         <template v-for="(item,index) in pages" >
          <slideritem  :key="index" :style="item.style" v-html="item.html" @click.native="handleSlider(item.id,item.newsType)"></slideritem>
         </template>
          <!-- 设置loading,可自定义 -->
          <div slot="loading">loading...</div>
        </slider>
		</div>
		
    <!-- 活动专题  1-->
    <!--
       id: {
            1: '市区周边宝典',
            2: '三江宝典',
            3: '融水宝典',
            4: '鹿寨宝典',
            5: '融安宝典',
            6: '柳城宝典',
            7: '柳江区宝典',
        },
    -->
    <div v-if="true" class="menu-components atc-components" v-bind:style="{height: DialogList.Act1Dialog.height,zIndex: DialogList.Act1Dialog.level + 4}"> 
      <img  src="static/img/act/1/bg.jpg" style="width: 100%;" v-if="DialogList.Act1Dialog.visible" />
      <div class="act-1-link" v-if="DialogList.Act1Dialog.visible" >
        <img src="static/img/act/1/1.png?v=1"  @click="displayActList(1,1)" />
        <img src="static/img/act/1/2.png?v=1"  @click="displayActList(1,2)" />
        <img src="static/img/act/1/3.png?v=1"  @click="displayActList(1,3)" />
        <img src="static/img/act/1/4.png?v=1"  @click="displayActList(1,4)" />
        <img src="static/img/act/1/5.png?v=1"  @click="displayActList(1,5)" />
        <img src="static/img/act/1/6.png?v=1"  @click="displayActList(1,6)" />
        <img src="static/img/act/1/7.png?v=1"  @click="displayActList(1,7)" />
      </div>
    </div>  
    <!-- 文章列表 -->
    <div v-if="true" class="comment-components act-1-newslist" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.Act1NewsListDialog.y,opacity:DialogList.Act1NewsListDialog.opacity,zIndex:DialogList.Act1NewsListDialog.level + 4 }"> 
      <!--<list-style-1 ref="actShiquList"></list-style-1>-->
      <listStyle1 v-if="firstActshiquListLoad" ref="actShiquList"  v-on:firstLoad="actShiquListLoad"></listStyle1>
    </div>           
    <!-- 文章列表 end --> 
    
    <!-- 活动专题 1 end -->
		 
		 
		 
    <!-- 活动专题  2 苗族系列坡会群 -->
    <!--
       id: {
            1: '1整英坡会',
            2: '2平卯坡会',
            3: '3整依直坡会',
            4: '4整堆坡会',
            5: '5安太坡会',
            6: '6古龙坡会',
            7: '7安陲芒嵩坡会',
        },
    -->
    <div v-if="true"  class="menu-components atc-components act2" style="background-color: #ffddb7 !important;" v-bind:style="{height: DialogList.Act2Dialog.height,zIndex: DialogList.Act2Dialog.level + 4}"> 
      <img  src="static/img/act/2/top.jpg" style="width: 100%;"  v-if="DialogList.Act2Dialog.visible"/>
      <img  src="static/img/act/2/title.jpg" style="width: 100%;"  v-if="DialogList.Act2Dialog.visible"/>
      <div style="text-align: center;background-color: #ffddb7;margin-top: 3%;">
        <img  src="static/img/act/2/btn-down.png" style="width: 8%; text-align: center;"  v-if="DialogList.Act2Dialog.visible" @click="displayAct2Desc()"  v-bind:class="{act2down:isActt2DescClass,act2downno:!isActt2DescClass}"/>
      </div> 
      <div class="act-2-desc" style="background-color: #ffddb7; font-size: 0.26rem;color: #0d0e10; width: 100%;overflow: hidden;" v-bind:style="{height: actt2DescHeight}">
        <div class="act-2-desc-content" style="background-color: #cfa06a; color: #0d0e10;    margin: 3% 5% 3% 5%;padding: 5%;    width: 80%; border-radius: 15px; overflow-y: auto;overflow-x: hidden;overflow-y: auto;overflow-x: hidden;height: 180px;" >
          <p>　　融水素有“百节之乡”的美誉，每年全县有大小节日上百个，分布在各个乡镇的村屯里。节日活动项目繁多，内容丰富多彩，既有传统祭祀、敬祖仪式，又有比赛娱乐项目，其中以吹芦笙跳踩堂最为盛行，苗、瑶、侗、壮族春节期间的活动都少不了这个节目。同时还有斗马、斗牛、斗鸡、赛马、芒篙等多项内容。其中，春节期间从正月初三至正月十七天天有坡会，称之为『苗族系列坡会群』，是指在每年春季的农历正月初三至十七这段时间内，广西壮族自治区融水县各乡镇村屯的节日活动。每天一个坡会，排列成序，连续不断，男女青年赶坡会应接不暇。是以苗族为主的各族人民悼念先烈、禳灾祈福、鼓舞斗志、交流感情、集体聚会娱乐的盛大民间传统节日。起源自然，文化形态体现在歌、舞、乐当中，『苗族系列坡会群』已被列为第一批国家非物质文化遗产名录。</p>
          <p>　　系列坡会群活动主要有：整英坡会（正月初三）、嘎直坡会（正月初四）、平卯坡会（正月初五）、沛松坡会（正月初六）、拱洞坡会（正月初七）、能邦坡会（正月初八）、乌勇芒篙坡会（正月初九）、整依直坡会（正月初十）、整堆坡会（正月十一）、百鸟衣坡会（正月十二）、安太坡会（正月十三）、更喔坡会（正月十四）、大坡坡会（正月十五）、古龙坡会（正月十六）、安陲芒篙坡会（正月十七）。</p>
        </div>
      </div>
      <img  src="static/img/act/2/list-title.jpg" style="width: 100%;"  v-if="DialogList.Act2Dialog.visible"/>
      <div style="position: relative;">
        <img  src="static/img/act/2/bg.jpg" style="width: 100%;"  v-if="DialogList.Act2Dialog.visible"/>
        <div class="act-2-link" v-if="DialogList.Act2Dialog.visible" >
          <img src="static/img/act/2/list/1.png?v=1"  @click="displayArticle(64045,0)" />
          <img src="static/img/act/2/list/2.png?v=1"  @click="displayArticle(64049,0)" />
          <img src="static/img/act/2/list/3.png?v=1"  @click="displayArticle(64057,0)" />
          <img src="static/img/act/2/list/4.png?v=1"  @click="displayArticle(64056,0)" />
          <img src="static/img/act/2/list/5.png?v=1"  @click="displayArticle(64055,0)" />
          <img src="static/img/act/2/list/6.png?v=1"  @click="displayArticle(64046,0)" />
          <img src="static/img/act/2/list/7.png?v=1"  @click="displayArticle(64053,0)" />
        </div>
      </div>
    </div>      
    <!-- 活动专题 1 end -->
		 
		 
		     
     

    <!-- 活动专题 3 大战歌 -->
    <div v-if="true"  class="menu-components atc-components act3" style="background-color: #FFFFFF !important;" v-bind:style="{height: DialogList.Act3Dialog.height,zIndex: DialogList.Act3Dialog.level + 4}"> 
      <act-3-main v-if="firstAct3MainLoad" ref="refAct3Main" v-on:firstLoad="act3MainLoad"></act-3-main>           
    </div>    
    <!-- 活动专题 3 end -->
     
    <!-- 活动专题 4 三月三，去撒欢 -->
    <div v-if="true" id="clickMe" class="menu-components atc-components act4" style="background-color: #FFFFFF !important;" v-bind:style="{height: DialogList.Act4Dialog.height,zIndex: DialogList.Act4Dialog.level + 4}" v-bind:class="{session:isAct4Scroll}"> 
      <act-4-main v-if="firstAct4MainLoad" ref="refAct4Main" v-on:firstLoad="act4MainLoad"></act-4-main>           
    </div>    
    <!-- 活动专题 4 end -->
     
		 
		 
		 
		 
		 
		 
		 
		 
		<!-- 鲜料-主菜单 -->
		<div class="menu-components"  v-bind:style="{ height: DialogList.NewMenuDialog.height}" style="z-index: 3 ;">
			<div class="content-wrap" style="height: 100%" >
				<van-cell-group class="new-menu">
		  			<van-cell value="闲游头条"  @click="handleToutiao()"><img src="static/img/new/menu/2.png?v=2" /></van-cell>
		  			<van-cell value="城事精选" @click="handleNew()"><img  src="static/img/new/menu/1.png?v=2" /></van-cell>
		  			<van-cell style="margin-bottom: 0.275rem;" value="乡旅动态" @click="handleRenyimen()"  ><img src="static/img/new/menu/3.png?v=2" /></van-cell>
				</van-cell-group>					
				<template>  
				  <specia-list-more :id="11" ref="speciaListMoreRef"></specia-list-more>
				</template>
			</div>	
 		</div>
 		
 		<!-- 城事精选 -->
      <div class="comment-components test-new" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.NewsListDialog.y,opacity:DialogList.NewsListDialog.opacity,zIndex:DialogList.NewsListDialog.level + 4 }"> 
       <listStyle1 v-if="firstNewsLoad" ref="newsList"  v-on:firstLoad="newsListLoad"></listStyle1>
      </div>           
   	<!-- 城事精选 end --> 
    
    <!-- 闲游头条 -->
      <div class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.ToutiaoListDialog.y,opacity:DialogList.ToutiaoListDialog.opacity,zIndex:DialogList.ToutiaoListDialog.level + 4 }"> 
        <listStyle1 v-if="firstToutiaoLoad" ref="toutiaoList"   v-on:firstLoad="toutiaoListLoad" ></listStyle1>        
      </div>           
    <!-- 闲游头条 end --> 
    
    <!-- 乡旅动态 -->
      <div class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.RenyimenListDialog.y,opacity:DialogList.RenyimenListDialog.opacity,zIndex:DialogList.RenyimenListDialog.level + 4 }"> 
        <listStyle1 v-if="firstRenyimenLoad" ref="renyimenList"   v-on:firstLoad="renyimenListLoad"></listStyle1>    
      </div>           
    <!-- 乡旅动态 end -->
   	 	 
   	 	
 		<!---------------------------------------- 趣玩 ---------------------------------------->
 		<div v-show="true" class="menu-components menu-play" v-bind:style="{ height: this.DialogList.PlayMenuDialog.height}" style="z-index: 3 ;">
   			<div class="content-wrap" >
		 	 	<!-- 菜单 -->
				<van-cell-group class="new-menu">  			
            <van-cell  value="VR赏全景"  @click="handleEnjoyVR()" ><img  src="static/img/pay/menu/7.png" /></van-cell>
		  			<van-cell value="趣玩攻略"   @click="handleGonglv()" ><img  src="static/img/pay/menu/2.png" /></van-cell>  			
            <van-cell value="达人游记"   @click="handleYouji()" ><img  src="static/img/pay/menu/6.png" /></van-cell>
		  			<van-cell style="margin-bottom: 0.275rem;" value="互动活动"  @click="handleCanyu()" ><img  src="static/img/pay/menu/3.png?v=2" /></van-cell>

				</van-cell-group>		
				<specia-list-more :id="12" ref="playSpeciaListRef"></specia-list-more>
			</div> 	
		</div>
    
		<!-- 达人游记 -->
      <div class="comment-components test-quancun" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.YoujiMenuDialog.y,opacity:DialogList.YoujiMenuDialog.opacity,zIndex:DialogList.YoujiMenuDialog.level + 4 }"> 
        <listStyle2 v-if="firstYoujiLoad" ref="refsYoujiList"   v-on:firstLoad="youjiListLoad"></listStyle2>
      </div>           
    <!-- 达人游记 end --> 

		<!-- 全村第一站 -->
      <div class="comment-components test-quancun" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.QuancunMenuDialog.y,opacity:DialogList.QuancunMenuDialog.opacity,zIndex:DialogList.QuancunMenuDialog.level + 4 }"> 
        <listStyle2 v-if="firstQuancunLoad" ref="quancunList"   v-on:firstLoad="quancunListLoad"></listStyle2>
      </div>           
    <!-- 全村第一站 end --> 
    
    <!-- 趣玩攻略 -->
      <div class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.GonglvMenuDialog.y,opacity:DialogList.GonglvMenuDialog.opacity,zIndex:DialogList.GonglvMenuDialog.level + 4 }"> 
        <funnyplayList  v-if="firstGonglvLoad" ref="gonglvList"   v-on:firstLoad="gonglvListLoad"></funnyplayList>
      </div>           
    <!-- 趣玩攻略 end --> 
    
    <!-- 互动活动 -->
      <div class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.CanyuMenuDialog.y,opacity:DialogList.CanyuMenuDialog.opacity,zIndex:DialogList.CanyuMenuDialog.level + 4 }">
        <listStyle3 v-if="firstCanyuLoad" ref="canyuList"   v-on:firstLoad="canyuListLoad"></listStyle3>
      </div>           
    <!-- 互动活动 end -->     
      
    <!-- 体验师推荐 -->
    <!--
      <div v-show="ExerciseDialog.visible" class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:ExerciseDialog.y,opacity:ExerciseDialog.opacity}"> 
        <list-style-5 ref="experList"></list-style-5>
      </div>        
    --> 
    <!--
      <div class="comment-components" style="overflow-y: scroll;background-color: rgba(0,0,0,0.5) !important;" v-bind:style="{ transform:DialogList.ExerciseMenuDialog.y,opacity:DialogList.ExerciseMenuDialog.opacity,zIndex:DialogList.ExerciseMenuDialog.level + 4 }" > 
       <img  src="static/img/pay/exercise/btn-close.png" style="position: absolute;top:3%;right: 13%;width: 7%;    padding: 2%;" @click="closeExercise()"/>
       <img  src="static/img/pay/exercise/info.png" style="width: 70%;margin-left: 15%;margin-top: 16%;"  v-if="DialogList.ExerciseMenuDialog.visible"/>
      </div> 
     -->     
    <!-- 体验师推荐 end --> 
    
    <!-- 体验师文章列表 -->   
      <div v-if="false" class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:ExerciseListDialog.y,opacity:ExerciseListDialog.opacity}"> 
<!--        <list-style-6 ref="experArticlesList"></list-style-6>-->
        <listStyle6 ref="experArticlesList"></listStyle6>
      </div>               
    <!-- 体验师推荐 end --> 
    
    <!-- 专题回顾 -->
    <div v-show="true" class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.ActListDialog.y,opacity:DialogList.ActListDialog.opacity,zIndex:(DialogList.ActListDialog.level + 4)}"> 
      <act-list v-if="firstActLoad" ref="refActList" v-on:firstLoad="actListLoad"></act-list>
    </div>
    <!-- 专题回顾 end -->    
    


    <!-- VR赏全景 -->
    <div v-show="true" class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.EnjoyActListDialog.y,opacity:DialogList.EnjoyActListDialog.opacity,zIndex:(DialogList.EnjoyActListDialog.level + 4)}"> 
      <enjoy-vr-list v-if="firstActLoad" ref="refEnjoyActList" v-on:firstLoad="actEnjoyListLoad"></enjoy-vr-list>
    </div>
    <!-- VR赏全景 end -->    



    <!---------------------------------------- 趣玩 end -------------------------------------->
    
		        
		      
    <!------------ 智图 ------------>
    <div v-show="true" class="menu-components menu-maps" v-bind:style="{ height: DialogList.MapsDialog.height}">
      <div v-show="mapsLoadingVisible" id="loading" class="maps-loading">
        <img class="maps-logo" src="static/img/index/logo.png" />
        <van-loading class="maps-conents-loading" color="#222633" v-if="true"/>
      </div>
      <iframe v-if="showMaps" @load="mapsLoaded"  :src="mapSrc" height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>  
    </div>
    <!------------ 智图 end --------->
		
		
    <!------------ 服务 --------->
 
 		<div v-show="true" class="menu-components menu-service" v-bind:style="{ height: DialogList.ServiceDialog.height }" style="z-index: 3 ;">
   			<div class="content-wrap">
		 	 	<!-- 菜单 -->
				<van-cell-group class="new-menu">  			
		  			<van-cell value="趣玩交通"  @click="displayServiceTraffic()"><img  src="static/img/service/menu/1.png?v=2" /></van-cell>
		  			<van-cell value="闲游天气"  @click="displayServiceWeather()"><img  src="static/img/service/menu/2.png?v=2" /></van-cell>
		  			<van-cell value="酒店民宿" @click="handleHotel()"><img  src="static/img/service/menu/3.png?v=2" /></van-cell>
		  			<van-cell value="柳味美食" @click="handleFood()"><img  src="static/img/service/menu/6.png?v=2" /></van-cell>
		  			<van-cell value="旅行社" @click="displayServiceGuild()"><img  src="static/img/service/menu/4.png?v=2" /></van-cell>
		  			<van-cell style="margin-bottom: 0.275rem;" value="联系我们" @click="displayServiceHelper()"><img  src="static/img/service/menu/5.png?v=2" /></van-cell>
				</van-cell-group>
        <specia-list-more :id="13" ref="serviceSpeciaListRef"></specia-list-more>
			</div>
		</div> 
		
    <!-- 酒店民宿 -->
      <div class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.HotelDialog.y,opacity:DialogList.HotelDialog.opacity,zIndex:DialogList.HotelDialog.level + 4 }"> 
        <listStyle4  v-if="firstHotelLoad" ref="hotelList" v-on:firstLoad="hotelListLoad"></listStyle4>
      </div>           
    <!-- 酒店民宿 end --> 
    
    <!-- 柳味美食 -->
      <div class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.FoodDialog.y,opacity:DialogList.FoodDialog.opacity,zIndex:DialogList.FoodDialog.level + 4 }"> 
        <listStyle1 v-if="firstFoodLoad" ref="foodList" v-on:firstLoad="foodLoad"></listStyle1>
      </div>           
    <!-- 柳味美食 end --> 
     
		   
		
	   		<!-- 服务 联系我们-->	
	   		<div v-show="true" class="menu-components" v-bind:style="{  height: DialogList.HelperDialog.height }">
	   			<div class="content-wrap">
			 	 	  <van-collapse v-model="activeHelper" accordion class="service-helper-collapse">
							<van-collapse-item name="1" >
						    <div slot="title"><img class="collapse-icon" src="static/img/service/helper/icon.png"/><span class="collapse-title">如何找我？</span></div>
						 		<img src="static/img/service/helper/info.jpg?v=2" v-if="DialogList.HelperDialog.visible"/>
						  </van-collapse-item>
					</van-collapse>
				</div>
			</div>
	   		<!-- 服务 联系我们END-->	 
	   			
	   		<!-- 服务,旅行社-->	
	   		<div v-show="true" class="menu-components" v-bind:style="{ height: DialogList.GuildDialog.height }">
	   			<div class="content-wrap service-guild" style="overflow: hidden;">
	   			 <div class="guild-filter">
	   			   <ul>
	   			     <li @click="displayFilCatagory">{{filCatagoryText}}<img src="static/img/filter-down.png" class="guild-filter-down"  :class="{'guild-filter-downed': guildFilterVisible == true}"/></li>
	   			     <li @click="displayFilRating">{{filRatingText}}<img src="static/img/filter-down.png" class="guild-filter-down"  :class="{'guild-filter-downed': guildFilterRatingVisible == true}"/></li>
	   			     <li @click="displayFilArea">{{filAreaText}}<img src="static/img/filter-down.png" class="guild-filter-down"  :class="{'guild-filter-downed': guildFilterAreaVisible == true}"/></li>
	   			   </ul>
	   			 </div>
	   			 <div v-if="guildLoading" class="van-list__loading van-list__loading-text" style="width: 100%;">
	   			   <span>正在加载...</span>
	   			 </div>
          <div  class="guild-result-info" v-if="(guildListData=='' || guildListData==null || guildListData ==[]) && !guildLoading" >            
            <van-tag plain type="success">无搜索结果</van-tag>
          </div>
					<van-list>
						<van-cell v-for="item in guildListData" :key="item.id">
							<div> 
								<div class="guild-list-content">
									<div  style="height: 100%;"> 
										<div class="content-title" style=" letter-spacing: 2px;">
											<div>{{item.name}}</div>
										</div>								
										<div class="guild-list-bottom">
										  <div class="content-address">{{item.address}}</div>
											<span>{{item.tel}}</span>
										</div>
									</div>
									<div>
										<a :href="'tel:'+item.tel">
											<img src="static/img/service/guild/dialing-v2.png"/>
										</a>
									</div>
								</div>
							</div>
						</van-cell>
					</van-list>
				</div>
			</div>
  			<van-popup v-model="guildFilterVisible" position="bottom" :overlay="true">
            <van-picker
           ref="filterCatagory" 
            show-toolbar
            title="类别"
            :columns="guildFilterCatagoryData"
            @cancel="onCancelCatagory"
            @confirm="onConfirmCatagory"
          />
        </van-popup>
  			<van-popup v-model="guildFilterRatingVisible" position="bottom" :overlay="true">
            <van-picker
              ref="filterRating" 
            show-toolbar
            title="等级"
            :columns="guildFilterRatingData"
            @cancel="onCancelRating"
            @confirm="onConfirmRating"
          />
        </van-popup>
        <van-popup v-model="guildFilterAreaVisible" position="bottom" :overlay="true">
          <van-picker
            ref="filterArea" 
          show-toolbar
          title="区域"          
          :columns="guildFilterAreaData"
          @cancel="onCancelArea"
          @confirm="onConfirmArea"
        />
      </van-popup>
	   		<!-- 服务,旅行社 end-->		   			 
	   			 
	   		<!-- 服务,趣玩交通-->
			<div v-show="true" class="menu-components"  v-bind:style="{ height:   DialogList.TrafficDialog.height  }">			  
				<div class="iframe-wrap" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;height: 108%;">
					<van-loading class="conents-loading" color="white" v-if="false"/>
					<iframe v-if="serviceClass.trafficSrc!=''"  @load="iframeLoaded" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;" :src="serviceClass.trafficSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0"></iframe>					
				</div>
			</div>
	   		<!-- 服务,趣玩交通 end-->	
	   		
	   		<!-- 服务,闲游天气-->
			<div v-show="true" class="menu-components"  v-bind:style="{ height: DialogList.WeatherDialog.height  }">			  
				<div class="iframe-wrap" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;height: 100%;">
					<van-loading class="conents-loading" color="white" v-if="false"/>
					<iframe  v-if="serviceClass.weatherSrc!=''" @load="iframeLoaded" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;overflow-x: hidden;width: 100%;" :src="serviceClass.weatherSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0"></iframe>
				</div>
			</div>
	   		<!-- 服务,闲游天气 end-->	
	   		
	   		<!-- 服务,乐享-->
			<div v-show="true" class="menu-components"  v-bind:style="{ height:  DialogList.LexiangDialog.height }">			  
				<div class="iframe-wrap" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;height: 100%;">
					<van-loading class="conents-loading" color="white" v-if="false"/>
					<iframe  v-if="serviceClass.lexiangSrc!=''"  @load="iframeLoaded" style="-webkit-overflow-scrolling:touch;overflow-y: scroll;" :src="serviceClass.lexiangSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0"></iframe>
				</div>
			</div>
	   		<!-- 服务,乐享 end-->	
	   		
	   		<!------------ 服务 end --------->
   			
		<!------------------------------------------ 搜索 ------------------------------------------> 
	   	<div v-show="true" class="menu-components" v-bind:style="{ height: DialogList.SearchDialog.height}">
	   			<div  class="search-header"> 
	   				<i class="van-icon van-icon-search search-icon-2"  @click="onSearch"></i>
		   			<van-search placeholder="想去哪里玩？" show-action  @search="onSearch"   v-model="keyWord" class="search-form-wrap">  <div slot="action" @click="onSearch"></div></van-search>					 
				</div>
				<div  class="search-contents">
          <!-- 排行榜 -->
				  <div class="search-top-wrap" v-if="firstSearch" >
				    <div class="search-top-banner">
				      <img src="static/img/top/banner.jpg" v-if="DialogList.FoodDialog.height!='0'"/>
				    </div>
				    <div class="top-list-item"  v-for="(item, index) in searchTopata" :key="item.ID" @click="displayArticle(item.ID,item.cid)" >
				        <div class="top-img" v-bind:style="{backgroundImage:'url(' + item.thumbnail + ')'}">
				           <img class="top-ico" src="static/img/top/top-1.png" v-if="index==0"/>
				           <img class="top-ico" src="static/img/top/top-2.png" v-if="index==1"/>
				           <img class="top-ico" src="static/img/top/top-3.png" v-if="index==2"/>
				        </div>
				        <div class="top-title">
				             {{item.LongTitle}}
				        </div>
                <div class="top-info">
                  <span>柳州必玩TOP榜</span>
                  <span  class="eye-wrap" style="float: right;"><img class="eye" src="static/img/eye.png"/>{{item.visits}}</span>
                </div>
				    </div>
				    <div class="search-top-more" @click="getTopData()" v-if="(!searchTopGoneVisible && searchTopata!=null && searchTopata.length>0)">
				              更多
				    </div>
             <div v-show="searchTopLoading" class="list-gone van-list__loading-text">
                                加载中...
            </div>
				     <div v-show="searchTopGoneVisible" class="list-gone van-list__loading-text">
                                我可是有底线的！
            </div>
				  </div>
          <!-- 排行榜 end -->
				     
					<!-- 鲜料 -->
					<div class="new-warp" v-if="searchNewData!=null && searchNewData.length>0 && !firstSearch" >
						<div class="search-item-title">鲜料</div>
						<div class="search-new-item" v-for="item in searchNewData" :key="item.ID">
							<div @click="displayArticle(item.ID,item.SID)" >
								<div class="search-new-item-left">
									<div class="list-title-base list-title-1">{{item.LongTitle}}</div>
									<div class="search-new-item-type">{{item.categoryName}}</div>
									<span class="search-new-item-visits"><img class="eye" src="static/img/eye.png" />{{item.visits}}</span>
								</div>
								<div class="search-new-item-right"  v-bind:style="{ backgroundImage: 'url('+item.thumbnail+')'}">
								  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
								</div>
							</div>
						</div>
						<div  class="result-info" v-if=" searchNewData=='' || searchNewData==null " >
							<span>无搜索结果</span>
						</div>
						<div class="search-more" @click="onMoreSearch(1)" v-if="searchNewMoreVisible">
							更多
						</div>
					</div>
					<!-- 鲜料 end-->
					
          <!-- 智图 -->
          <div class="new-warp" v-if="searchMapsData!=null && searchMapsData.length>0 && !firstSearch" >
            <div class="search-item-title">智图</div>
            <div class="search-new-item" v-for="item in searchMapsData" :key="item.ID">
              <div @click="displayMapArticle(item.ID,209)" >
                <div class="search-new-item-left">
                  <div class="search-new-item-title">{{item.LongTitle}}</div>
                  <div class="search-new-item-type">{{item.categoryName}}</div>
                  <span class="search-new-item-visits"><img class="eye" src="static/img/eye.png" />{{item.visits}}</span>
                </div>
                <div class="search-new-item-right"  v-bind:style="{ backgroundImage: 'url('+item.thumbnail+')'}">
                  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
                </div>
              </div>
            </div>
            <div  class="result-info" v-if=" searchMapsData=='' || searchMapsData==null " >
              <span>无搜索结果</span>
            </div>
            <div class="search-more" @click="onMoreSearch(2)" v-if="searchMapsMoreVisible">
                              更多
            </div>
          </div>
          <!-- 智图 end-->
          
					<!-- 趣玩 -->
					<div class="funnyplay-warp"  v-if="searchPlayData!=null && searchPlayData.length>0 && !firstSearch" >
							<div class="search-item-title">趣玩</div> 
							<div class="search-funnyplay-item"  v-for="item in searchPlayData" :key="item.ID" @click="displayArticle(item.ID,item.cid)" >
								<div class="search-funnyplay-item-img"  v-bind:style="{ backgroundImage: 'url('+item.thumbnail+')'}">
								  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
								</div>
								<div class="search-funnyplay-contents">
									<div class="search-funnyplay-title">{{item.LongTitle}}</div>
									<div class="search-funnyplay-type">{{item.categoryName}}</div>
									<div class="search-funnyplay-visits"><img class="eye" src="static/img/eye.png" />{{item.visits}}</div>
								</div>
							</div> 
            <div class="search-more"  @click="onMoreSearch(3)"v-if="searchPlayMoreVisible">更多</div>   
					</div>			
					<!-- 趣玩 end-->					
					
					<!-- 互动活动 -->
					<div class="recruitfunny-warp"  v-if="searchPlayRecruitData!=null && searchPlayRecruitData.length>0 && !firstSearch" >
							<div class="search-item-title">互动活动1</div>
							
							<div class="search-recruitfunny-item"  v-for="item in searchPlayRecruitData" :key="item.ID">							  
							  <a :href="item.nURL" target="_blank">							    
  								<div class="search-recruitfunny-item-img" v-bind:style="{ backgroundImage: 'url('+item.thumbnail+')'}">
  								  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
  								</div>
  								<div class="search-recruitfunny-item-contents">	
  									<div class="search-recruitfunny-item-left">
  										<div class="search-recruitfunny-item-title">{{item.LongTitle}}</div>
  										<div class="search-recruitfunny-item-type">互动活动</div>
  										<div class="search-recruitfunny-item-visits"><img class="eye" src="static/img/eye.png" />{{item.visits}}</div>
  									</div>
  									<div class="search-recruitfunny-item-go">
  										<img src="static/img/pay/recruit/go.png">
  									</div>
  								</div>
								</a>
							</div>
							<div class="search-more"  @click="onMoreSearch(4)"  v-if="searchPlayRecruitMoreVisible">
								更多
							</div>
					</div>
					<!-- 互动活动 end--> 
					
          <!-- 服务 -->
          <div class="new-warp" v-if="searchServiceData!=null && searchServiceData.length>0 && !firstSearch" >
            <div class="search-item-title">服务</div>
            <div class="search-new-item" v-for="item in searchServiceData" :key="item.ID" @click="displayArticle(item.ID,item.cid)" >
              <div @click="displayArticle(item.ID,item.SID)" >
                <div class="search-new-item-left">
                  <div class="search-new-item-title">{{item.LongTitle}}</div>
                  <div class="search-new-item-type">{{item.categoryName}}</div>
                  <span class="search-new-item-visits"><img class="eye" src="static/img/eye.png"/>{{item.visits}}</span>
                </div>
                <div class="search-new-item-right"  v-bind:style="{ backgroundImage: 'url('+item.thumbnail+')'}">
                  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
                </div>
              </div>
            </div>
            <div  class="result-info" v-if=" searchServiceData=='' || searchServiceData==null " >
              <span>无搜索结果</span>
            </div>
            <div class="search-more" @click="onMoreSearch(5)" v-if="searchServiceMoreVisible">
                                更多
            </div>
          </div>
          <!-- 服务 end-->
				</div>
			</div>  
    <!------------------------------------------ 搜索 end ------------------------------------------> 
		  
    <!------------------------------------------ 文章  ----------------------------------------------> 
    <!-- 文章内容 -->
    <div  ref="articleBox" id="articleWrap" class="article-components"  style="position: absolute;"  v-bind:style="{ transform:DialogList.ArticleDialog.y,opacity:DialogList.ArticleDialog.opacity,zIndex:DialogList.ArticleDialog.level + 4 }" > 
      <back-to-top transitionName="fade" :customStyle="myBackToTopStyle" :visibilityHeight="300" :backPosition="50"></back-to-top>
      <img v-show="backtotopVisible" class="btn-backtotop" src="static/img/backtotop.png" @click="handleBacktotop"/>        
      <van-loading class="conents-loading" color="white" v-if="conentsLoading"/> 
        <!-- 普通文章头部 -->
        <div  v-show="!mapArticleVisible && news.sid!=208 && news.cid!=209" class="server-news-title-wrap"   v-bind:style="{ backgroundImage: 'url(static/img/article/bg.png),url('+news.thumbnail+')'}">
          <!-- templet master-->
          <div class="article-icon-warp"> 
            <img class="btn-navigation" src="static/img/comments/icon-navigation.png" v-if="(news.latlng && news.latlng != null)"  @click="handleNavigation"/>
            <img class="btn-vr" src="static/img/btn-vr.png"   v-if="(news.vr && news.vr != null && !MPWEIXIN)"  @click="handleVr(news.vr)" />
            <div class="btn-comments-warp" @click="handleComment">
              <img class="btn-comments" src="static/img/comments/btn-comments.png"  v-if=" news.title !='' " style=""/>
              <span class="comments-total" v-if='commentTotal>0'>{{commentTotal}}</span>
            </div>
          </div>
          <!-- templet master end -->
          <h2>{{news.title}}</h2>
          <div class="server-news-info-wrap"><span>{{news.categoryName}}　<span class="article-createtime">{{news.addTime}}</span></span><span  class="eye-wrap" v-if=" news.title !='' " ><img class="eye" src="static/img/article/eye.png"  /> {{news.visits}}</span></div>
         </div>
        <!-- 普通文章头部 end-->
        
        <!-- 酒店民宿文章头部 -->
        <div  v-show="news.sid==208" class="server-news-title-wrap"   v-bind:style="{ backgroundImage: 'url(static/img/article/bg.png),url('+news.thumbnail+')'}" style="     max-height: 135px;padding: 34% 4.67% 4.67% 4.67%; height: 29.66%;">
          <!-- templet-->
          <div class="article-icon-warp"> 
            <img class="btn-navigation" src="static/img/comments/icon-navigation.png" v-if="(news.latlng && news.latlng != null)"  @click="handleNavigation"/>
            <img class="btn-vr" src="static/img/btn-vr.png"   v-if="(news.vr && news.vr != null && !MPWEIXIN)"  @click="handleVr(news.vr)" />
            <div class="btn-comments-warp" @click="handleComment">
              <img class="btn-comments" src="static/img/comments/btn-comments.png"  v-if=" news.title !='' " style=""/>
              <span class="comments-total" v-if='commentTotal>0'>{{commentTotal}}</span>
            </div>
          </div>
          <!-- templet end -->
           
           <h2>{{news.title}}</h2>
          <div class="info-wrap" style="color: #FFF;">
            
            <div class="info-tel" style="line-height: 25px;">
              <span>星级： <img class="eye" src="static/img/service/hotel/star-w.png" v-for="(starItem,starIndex) in news.star" style="width: 4% !important;"/>
               </span>
            </div> 
            <span>地址：{{news.address}}</span>
            <div class="info-tel" style="line-height: 25px;width: 91%;">
              <span>联系电话：{{news.tel }}</span>
              <span  class="eye-wrap" style="float: right;"><img class="eye" src="static/img/article/eye.png"/> {{news.visits}}</span></div>
          </div> 
        </div>
        <!-- 酒店民宿文章头部 end -->
          
        <!-- 地图文章头部 -->
        <div v-show="news.cid==209" class="server-news-title-wrap server-news-map-title-wrap"   v-bind:style="{ backgroundImage: 'url(static/img/article/bg.png),url('+news.thumbnail+')'}" >
          <!-- templet-->
          <div class="article-icon-warp"> 
            <img class="btn-navigation" src="static/img/comments/icon-navigation.png" v-if="(news.latlng && news.latlng != null)"  @click="handleNavigation"/>
            <img class="btn-vr" src="static/img/btn-vr.png"   v-if="(news.vr && news.vr != null && !MPWEIXIN)"  @click="handleVr(news.vr)" />
            <div class="btn-comments-warp" @click="handleComment">
              <img class="btn-comments" src="static/img/comments/btn-comments.png"  style=""/>
              <span class="comments-total" v-if='commentTotal>0'>{{commentTotal}}</span>
            </div>
          </div>
          <!-- templet end -->          
          <h2>{{news.title}}</h2>
          <div class="info-wrap">
            <span>地址：{{news.address}}</span>
            <div class="info-tel"  style="line-height: 25px;width: 91%;">
              <span>电话：{{news.tel }}</span>
              <span  class="eye-wrap"><img class="eye" src="static/img/article/eye.png" /> {{news.visits}}</span></div>
          </div>
        </div>
        <!-- 地图文章头部 end -->
         
        <div class="server-news-contents" v-html='news.contents'></div>
        <div class="copyright-wrap">                
          <p>{{news.copyright}}</p>
          <div class="copyright-ad">
            <img :src="news.ad">
          </div>
        </div>
        
        
        
        
    </div>
    <!-- 文章内容 end--> 
    
    <!-- 评论窗口 -->
    <div class="comment-components pinglun" v-bind:style="{transform:DialogList.CommentDialog.y,opacity:DialogList.CommentDialog.opacity,zIndex:DialogList.CommentDialog.level + 4 }"> 
      <comments  v-if="firstCommentsLoad" v-on:firstLoad="articleCommentsLoad" ref="articleComments" contents-id="58691"></comments>
      <!--<van-icon name="upgrade" class="comment-close" @click="closeComment"/>-->
    </div>
    <!-- 评论窗口 END-->
    
    <!-- 地图导航窗口 -->
    <div class="comment-navigation" v-bind:style="{ transform:DialogList.NavigationDialog.y,opacity:DialogList.NavigationDialog.opacity,zIndex:DialogList.NavigationDialog.level + 4 }" >     
      <iframe :src="navigationSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>    
    </div> 
    <!-- 地图导航窗口 END-->
    
    <!-- VR窗口 -->
    <div class="comment-vr" v-bind:style="{ transform:DialogList.VrDialog.y,opacity:DialogList.VrDialog.opacity,zIndex:DialogList.VrDialog.level + 4  }">      
      <iframe v-if="vrSrc != null && vrSrc != ''" :src="vrSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>    
    </div>
    <!-- VR窗口 END-->       
    
    <!------------------------------------------ 文章 end ------------------------------------------> 
      
      
		 
		 
		 
		 
    
    
    <!-- 一级遮罩层 { opacity:oneLevelModalMaskOpacity}-->   
      <div v-show="oneLevelModalMaskVisible" class="modal-mask level-1" style="z-index: 4; " v-bind:style="{ opacity:1}" @click="closeOneLevelModalMask" ></div>
    <!-- 一级遮罩层 end -->
    
    <!-- 底部导航 -->  
	  <van-tabbar v-model="active" class="bottom-nav"  v-bind:style="{ backgroundColor:  activeColor}">	   	  
		  <van-tabbar-item  @click="handleNavNew">
		    <span>鲜料</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.newsActive : icon.news"  />
		    </template>
		  </van-tabbar-item> 
		  <!--<van-tabbar-item :to="'/maps'">-->
      <van-tabbar-item @click="handleNavMaps">
		    <span>智图</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.mapsActive : icon.maps" />
		    </template>
		  </van-tabbar-item> 		  
		  <van-tabbar-item @click="handleNavPlay">
		    <span>趣玩</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.payActive : icon.pay"  />
		    </template>
		  </van-tabbar-item>
		  <van-tabbar-item  @click="handleNavService">
		    <span>服务</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.serviceActive: icon.service"  />
		    </template>
		  </van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import { Tabbar, TabbarItem,Toast,CellGroup,Dialog  } from 'vant';
 	import { NavBar,Tab, Tabs ,Search,Button,Field,Popup,Tag} from 'vant';
 	import { Collapse, CollapseItem } from 'vant';
  import { List,Cell } from 'vant';
  import { Row, Col } from 'vant'; 
  import { Loading,Picker,Icon   } from 'vant';
  
  
	import axios from 'axios';
 	import qs from 'qs';
 	import Cookies from 'js-cookie';
 	import {slider,slideritem} from 'vue-concise-slider';
  import request from '@/utils/request'
  
    
   import BackToTop from '@/components/BackToTop.vue' 
   
   import SpeciaListMoreComponents from '@/components/more.vue' 
   
   
  import ExerciseDialog from '@/api/ExerciseDialog' 
  import ExerciseListDialog from '@/api/ExerciseListDialog' 
  //活动窗口
  
  import {SearchDialog} from '@/api/MenuDialog'
  import {EnjoyActListDialog,ActListDialog,ArticleDialog,CommentDialog,Act2Dialog,Act3Dialog,Act4Dialog} from '@/api/MenuDialog'
  import {Act1Dialog,Act1NewsListDialog} from '@/api/MenuDialog'
  
  import {NewMenuDialog,NewsListDialog,ToutiaoListDialog,RenyimenListDialog} from '@/api/MenuDialog'
  import {MapsDialog,NavigationDialog,VrDialog} from '@/api/MenuDialog'
  import {PlayMenuDialog,QuancunMenuDialog,GonglvMenuDialog,CanyuMenuDialog,ExerciseMenuDialog,YoujiMenuDialog} from '@/api/MenuDialog'
  import {ServiceDialog,TrafficDialog,WeatherDialog,HotelDialog,FoodDialog,GuildDialog,HelperDialog,LexiangDialog} from '@/api/MenuDialog'
  
  
  
  
  //-API  
  import SpecialAPI from '@/api/special'
  import ExperiencerAPI from '@/api/experiencer'
   
 	//轮播
 	import Swiper from 'swiper' 
  import 'swiper/dist/css/swiper.min.css'
  
  //专题活动
  import Act10Banner from '@/components/act/10/Banner.vue' 
  
export default {
  name: 'HelloWorld',
	components: {
	  listStyle1:()=>{
	    return import('@/components/list/ListStyle1.vue')
	  },
    listStyle2:()=>{
      return import('@/components/list/ListStyle2.vue')
    },
    funnyplayList:()=>{
      return import('@/components/funnyplay/ListStyle2.vue')
    },
    listStyle3:()=>{
      return import('@/components/list/ListStyle3.vue')
    },
    listStyle4:()=>{
      return import('@/components/list/ListStyle4.vue')
    },
    listStyle5:()=>{
      return import('@/components/list/ListStyle5.vue')
    },
    listStyle6:()=>{
      return import('@/components/list/ListStyle6.vue')
    },
    'act-list':()=>{
      return import('@/components/list/ActList.vue')
    },
    'enjoy-vr-list':()=>{
      return import('@/components/list/EnjoyVrList.vue')
    },
    'act-3-main':()=>{
      return import('@/components/act/3/main.vue')
    },
    'act-4-main':()=>{
      return import('@/components/act/4/main.vue')
    },
    'back-to-top':BackToTop,
    'specia-list-more':SpeciaListMoreComponents,
    'act-10-banenr':Act10Banner,
    //'list-style-1':ListStyle1,
    //'list-style-2':ListStyle2,
    //'list-style-3':ListStyle3,
    //'list-style-4':ListStyle4,
    //'list-style-5':ListStyle5,
    //'list-style-6':ListStyle6, 
    //'act-list':ActList, 
    
    
	  'comments':()=>{
      return import('@/components/comments.vue')
	  },
		'van-tabbar':Tabbar,
		'van-icon':Icon,
		'van-tabbar-item':TabbarItem,
		'van-nav-bar':NavBar,
		'van-tabs':Tabs,
		'van-tab':Tab,		
		'van-search':Search,
		'van-popup':Popup,
    'van-picker':Picker,
		'van-field':Field,
		'van-cell-group':CellGroup, 
		'van-button':Button,
		'van-list':List,
		'van-cell':Cell,
		'van-tag':Tag,
		'van-col':Col,
		'van-row':Row,
		'van-collapse':Collapse,
		'van-collapse-item':CollapseItem,
		'van-dialog':Dialog,
			'van-loading': Loading,
		slider,
		slideritem,
	},
  data () {
    return {
      isiOS:false,
      onDebug:false,
      debugInfo:'',
      //-窗口=====================================
      
      ExerciseDialog:ExerciseDialog,      
      ExerciseListDialog:ExerciseListDialog,       
      DialogList:{
        //搜索
        SearchDialog:SearchDialog,
        //鲜料菜单
        NewMenuDialog:NewMenuDialog,
        NewsListDialog:NewsListDialog,
        ToutiaoListDialog:ToutiaoListDialog,
        RenyimenListDialog:RenyimenListDialog,        
        //智图
        MapsDialog:MapsDialog,
        NavigationDialog:NavigationDialog,
        VrDialog:VrDialog,
        //趣玩菜单
        PlayMenuDialog:PlayMenuDialog,
        YoujiMenuDialog:YoujiMenuDialog,
        QuancunMenuDialog:QuancunMenuDialog,
        GonglvMenuDialog:GonglvMenuDialog,
        CanyuMenuDialog:CanyuMenuDialog,
        ExerciseMenuDialog:ExerciseMenuDialog,
        //服务
        ServiceDialog:ServiceDialog,
        TrafficDialog:TrafficDialog,
        WeatherDialog:WeatherDialog,
        HotelDialog:HotelDialog,
        FoodDialog:FoodDialog,
        GuildDialog:GuildDialog,
        HelperDialog:HelperDialog,
        LexiangDialog:LexiangDialog,
        //文章内容
        ArticleDialog:ArticleDialog,
        //评论
        CommentDialog:CommentDialog,
        ActListDialog:ActListDialog,
        EnjoyActListDialog:EnjoyActListDialog,//VR赏全景
        //活动窗口
        Act1Dialog,Act1Dialog,
        Act1NewsListDialog:Act1NewsListDialog,
        Act2Dialog:Act2Dialog,
        Act3Dialog:Act3Dialog,
        Act4Dialog:Act4Dialog,
      },
      //-窗口=====================================
      
      firstActLoad:false,
      firstHotelLoad:false,
      firstFoodLoad:false,
      firstNewsLoad:false,
      firstToutiaoLoad:false,
      firstRenyimenLoad:false,      
      firstActshiquListLoad:false,
      firstQuancunLoad:false,
      firstYoujiLoad:false,
      firstGonglvLoad:false,
      firstCanyuLoad:false,
      firstExperArticlesLoad:false,
      firstCommentsLoad:false,
      
      firstAct3MainLoad:false,
      firstAct4MainLoad:false,
      isAct4Scroll:false,
      
      act1Data:{
        cid:0,
        type:0,
        idArray:'',
      },
      //-======================= 专题活动       
      //-1
      //-1 end
      //-2
      actt2DescHeight:'0px',
      isActt2DescClass:false,
      //-2 end
      
      //-3
      actt3DescHeight:'0px',
      isActt3DescClass:false,
      
      actt3Contents1Height:'89px',
      actt3Contents1BeginHeight:'89px',
      actt3Contents1EndHeight:'89px',
      
      isActt3Contents1Class:false,
      
      act3Swiper1:'',
      act3Swiper2:'',
      act3Swiper3:'',
      
      
      actt3Contents3Height:'89px',
      actt3Contents3BeginHeight:'89px',
      actt3Contents3EndHeight:'89px',
      isActt3Contents3Class:false,
      //-3 end
      
      //-======================= 专题活动 end        
      
      
      routeHistory:[],
      documentTitle:'乡村闲游',
      maxHeight:'100%',
      isBack:true,
      myBackToTopStyle: {
        right: '50px',
        bottom: '50px',
        width: '40px',
        height: '40px',
        'border-radius': '4px',
        'line-height': '45px', // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: '#e7eaf1'// 按钮的背景颜色 The background color of the button
      },
      news:{
        id:0,
        sid:0,
        cid:0,
        title:'',
        contents:'',     
        categoryName:'',
        thumbnail:'',
        addTime:'',
        visits:0, 
        address:'',
        tel:'',        
        copyright:'',
        ad:'',
        latlng:'',
      },
      
      //-遮罩层=========================================================
      oneLevelModalMaskVisible:false,
      oneLevelModalMaskOpacity:0,
      //-遮罩层 end =====================================================
      
      //-鲜料=========================================================
      
      
      
      //村长甄选      
      newZhenListVisible:false,
      newZhenListY:'translateY(-100%)',
      newZhenListOpacity:0,
      newsSpecialList:[],
      newMenuY:'translateY(-100%)',
      newMenuVisible:false,
      newZhenSpecialQuery:{      
        zid:11,
        cid:0,
        pageIndex: 1,
        pageSize: 4        
      },      
      newsMoreVisible:true,
      newsMoreLoading:false,
      //-鲜料 end =====================================================
      
      
          
      
      
        //-文章=====================
        newsId:0,
        isHotelArticle:false,
        mapArticleVisible:false,
        articleVisible:false,
        displayArticleTimer:'',
        articleY:'translateY(-100%)',
        articleOpacity:0,
        articleSrc:'',
        commentTotal:0,
        backtotopVisible:false,
        
        
        //-文章 end =================
        
       
        
        
          
        //-搜索 =================
          keyWord:'',
          firstSearch:true,
          searchPageSize:3,
          searchQuery: {
            pageIndex: 1,
            pageSize: 3,
          }, 
      
        //鲜料
        searchNewData:[],
        searchNewMoreVisible:true,
        searchNewQuery: {
            pageIndex: 2,
            pageSize: 3,
        }, 
         //智图
        searchMapsData:[],
        searchMapsMoreVisible:true,
        searchMapsQuery: {
            pageIndex: 2,
            pageSize: 3,
        }, 
         //趣玩
        searchPlayData:[],         
        searchPlayMoreVisible:true,
        searchPlayQuery: {
            pageIndex: 2,
            pageSize: 3,
        }, 
        //互动活动
        searchPlayRecruitData:[],      
        searchPlayRecruitMoreVisible:true,
        searchPlayRecruitQuery: {
            pageIndex: 2,
            pageSize: 3,
        }, 
        //服务
        searchServiceData:[], 
        searchServiceMoreVisible:true,
        searchServiceQuery: {
            pageIndex: 2,
            pageSize: 3,
        }, 
          
        //-评论 end ==============

          
        //-搜索-排行榜 =================     
          searchTopata:[],
          searchTopGoneVisible:false, 
          searchTopLoading:true,
          topListQuery: {
            pageIndex: 1,
            pageSize: 10,
          },  
        //-评论-排行榜 end ==============
        
        modalMaskVisible:false,
        modalMaskOpacity:0,
        
        
        //-智图
        mapsLoadingVisible:false,
        mapSrc:this.HOST + '/View/Map.aspx',
        showMaps:false,
        mapArticleVisible:false,
        navigationVisible:false,
        navigationSrc:'',
        navigationY:'',
        navigationOpacity:0,
        
        //VR
        
        vrSrc:'',
        //-智图 end
        
        
        
        
      typeActive:0,
      active: 10,
      
      activeHelper:'1',
      moreType:false,
      showLib:false,
      showSortOrder:false, 
      
      icon: {
        news:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAk1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ROyVeAAAAMHRSTlMAlPZUiBYTCwd/N/ny5Ne5hW1dA+jdxLCon09MSB7IvZd1KxoQ0MybjT4nIu+jeFORuveCAAABOElEQVRIx+3TyY6CQBSF4RIp5kmUQRClcban8/5P13bSJA3UcE1c+m1Y/dG6dYs9j+VGfuRyRmfvgADYHeiJiSDZuAEu5GJ5gnv/uDiSEydCff9UyJbkJkfBGS+wZWTeCnESY3WljzgN8SusqX9skeOPEX+TfmKNfwxXXxxKDJmEWxxbaIrax9jKUy9XgalWmWx8TIUe/SS9N0WxzyFSKm7U+4BI1MmTOYT8jWJVIJbKkwR48PzLGcQSaeKsIXaRr2QBsbM0uUUQ23HyuvSMq25g9JG9Z5DZNuqLpF9mc4RcvhclXxggPGcvwID+OVsx1GJrvCsmdExnNGDo3YYJz6CTjYfWme1MpTU79kx2lc57aeVQEucMo4c1KWHNFr1Tw2h4/6A/Of04dRkGYVnZD83A4pbNXiZ+AA/MjfQ1ch3CAAAAAElFTkSuQmCC',
        newsActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAhFBMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUNCnCUgAAAAK3RSTlMAlPWHVIBKFhMLBzfw6NfOxbltXU8D+OTdvbCoHhqfl3UrEKObiz4nInhT9xpwsgAAAS5JREFUSMftk8lugzAURQkOmHmeIVAytr3//39NpURqDLYfUpY9G6+O7HfftfE+HCuqIotvMNwWCID2SFcYAmZbAS5ko4xh3Q8LMVnxItj3o0BTkp0EHTd4h8Qg44dIWYrwSo84D/FLbVMfliV4YKbfpCtG/MG09MaxxyuMsEWRTGPYFURCX12uDkumrZcAta+bZMmHwji0WKMvFUUJsEY0y5U9VqlsRVWwTq6fnj5/uZMo8qJ5o0S5yCvZSZSzVLlFEqU9SOsCCeZVFxg9ss8GMuJBvUj6MocYcpLVAL6gItO2mPKdnRRqUkfsCoMO5gkBQ8/tVeENdDRiaDObdiomNhvvxC3y/ZO88CiKd4b5BCNJMYZEqCMBfnoYJ75hnL42675wN2XgcMc1/lnwAx0Vf289P+91AAAAAElFTkSuQmCC',
        maps:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAmVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////VHQRUAAAAMnRSTlMAwHD9CQb69u6VRBoC6cSsnIRIL+HcuLF5amE5Hw3JvYh/XM+mV1Q+PBHk14w0JhTwTNaxRx0AAAGbSURBVEjH7ZXpcoIwFIVTwqYgoOwgivtWa3vf/+GahMgQHRKcaf95fuUw55sk914m6K/kZMsJ4Cgt9IGAXlvANSmGbbGBjraGmrjFICh1lUgCD1qpiF17DZsvzLkC4RcZOQiFCV/LiS9gyhrnN/vJkTULRQYvnsms/GSZeJQFswcpsmKZz7tdDkAKlvG4M2xmQ+7KpzkZVwgdgWncPSbWSfyYJRaI8alnwh6hE2Ype0Y+unljLmS9pYsOQuNUAb8w1SbYRtD2xbUfEOA6UxyeRHYsoQeBK++loAlpUt2LTHldqYSPUS9ydhGaPRCWQ+vYiwAtlNe6tq2BBEmIK7FwkxOpvCVBgDZ41EV2bIpkiE9sFYvesaTIB/Vhm4kr9teoEVRw9x0So4EaaU9v0uncYzVS6rwEeIeIPkCNaInBGLxGgxFIKZOz+R+KwFJHTON8MAKLGyMsbTgClzmplQmvIGAfcgyvIUCAVxF4I/+CREFBml791Av8jNipdhWROFh3HqtqVnsmR5p4KL7lJO60RngNcoR8n8bfuusXYnzRamp4tGoAAAAASUVORK5CYII=',
        mapsActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAjVBMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUPLF8SZAAAALnRSTlMAwHD7Cgbv6ayViYNJRBycPS8Q4dzFsXxqYVY5+PTKvbhc0CAY5NemdTQmw7pSNoULQAAAAYhJREFUSMftldlygkAQRW8cQEQEARdWRU1csvT/f15mi3G0hLEqD3nwPHGr+tR090CBv+L1uB4SyxaFYyk4QU2aYWFlRFu6wHctmpqRwaJf+aQrln1GeR7DI0UdoRs9yIjXJa1+7jbejWZ8dV63siFB5upVMBl3ncrSbGUl49RCCaBZWygFCeY6uWpriU4VrnAmKTAlyQSSowzM4eXTZduQWT6eMyqBVCleCE7OZNjzxwMJcEaUC2I5sGIbHzL6vRfvSiHNm9DphhCo6I5CJ3WXJkMXCO4qgdqryRhAdkdRnYVkUkdqj6ZitI0PEhgnxx1Ky1NlTpICadOhUMXj6FIp5Ra7FJ9HZ2bmqOlUXkROatLMUvnV9CsodPISHgZko+jumXg7S9avVI5eASvBeaF+ZdC60mEbWCu0EE4e4gGF1g4kk9xaoVUqjWZgr9B+B3wxekSh4TRnZK/88FT+h5LFRQQ4YbBit4q3GJxMZRZvdtBIbc60osoTGPDyCBrzb5ADvs/Ln5z5Bm8qwARlKqWAAAAAAElFTkSuQmCC',
        pay:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAApVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+4/eNVAAAANnRSTlMA78kP+Xb1ChJMLuFyM/LYhc2WkRgU7NzTw7scv7Sgm459WLqmgVMGA/vlrFwpIaNsY0I5AsgkhPa7AAABt0lEQVRIx+3VyXaqQBCA4UJomVFQGSIzAs5TTL//o90iN8G0oMjJJicn/8YF/UkVC4DWSlHRslFYTEV4ruXuGKgGpYLtWrJ0ga4uOy1wOPqRsDYtmX8IFG3j2pRJUL3JXaWTjfl5nlWOH8tS8//JYsDRu61GwfgsMkKMaGemzpJ0Y3cIL9l/AXtcb3o6rB8AP6nucV0otooZAL9dqO3nBT9X8NhrMqmJS9eWPMXxtgunCYZevgMoX4lJhZoM8AIXyXOAZXGLjLccdxB1BHiIIXjxUCGQF86qBtwgmb8Dl9ImwYabajw4h6rwAUg1rpKMKL1DEAXFrFo0QmSY/0GOoz4giLKUx510y9MQlMpYXdEOgjv5W0SitISLElcjdhLM9k6IQLcY0CQsikU4ugieJzTgwaK0L5kI/UjWn7z8LhIPe5NxT+L1JwPpJxCzP3nrT05uG0mMxhstrAl+58wmIdwtkOdwrVQ09hm4t8SIELAtdc2j10YzhnA1YNM1v53YVjEFrB29rBpkHaUSPEgh2ZAhapjy0NGOZMY70fDHCVMRnmhPfA7JkVMPCJ5sTnIezvG2hL++3z/3mf8b8/frVAAAAABJRU5ErkJggg==',
        payActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAjVBMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUPLF8SZAAAALnRSTlMA7snxD/l29QqQLRLh1rtMAnIyhX6WHducGBTMolkFwrS/plP75qxoXtBCOSTENdtAswAAAahJREFUSMft1clugzAQBuAhBocdTNgS9pB94f0fr+O2QYApCcqlUvtfEPJ89pgDA6PJVZ3ZVlyvVRdeiZvfWGmSplEkK3AM9znQWRlJzXeUfRI48iTQ2cF61D+Uedd+Uq5HD8mjvq+iSnMMcX+6XbT1YnZWubqoPaHGzdMkXp9kB+mJKPywA0K83vqU7idA5fMzjJZoQb0BkE9bc7xeqXwdwL36WkvOzT5w1tjeaRuJYFlwkF9p0igtWeCCFDshLtRDRBb+DTfz6JkX9Qguphy5zjbadUH4CSx8EQm2cODtwSU1lS+QUN6u7uPJInmgst7wi8aIWoAfZYIgsjMZkRcUDEGur8xdM00wpOBINVxwdY23+Jzgyv2ICLygA0QyRJoKRwvB66QpZQjwMZco84gtg/bHyXI2Wc0kxXyyMH4DSV4l5J1TjtYY8YnwR0tbgnPuLBJKhsAJu9PRY/3urCEhMYLhRGJFl2x6ROJgJB6rxokU1GvAjCN7J5B9nBmTA5bayx4x40wcriLC2mgDjCBIMxVeyI1WEpIjEcBEQrqS4aKdcvjP+/kAad3aBPB8MKUAAAAASUVORK5CYII=',
        service:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMA/d3n7jP54qsDnnTVjC8rEgzq2MbAknhiU00XBvPMvLezhG5qCKNwV0pFKCLwmW9bUDzedV2fAAABe0lEQVRIx+2UaXOCMBCGCYT78EIOURTB+2z3//+3UjNqrFlNZjr91OcjycM7s9ld7RfpONTZKRluAkASV0XZ6AAw2KqEeKRVyFFB+bAB1GLGS3JRiOcqhgDoI5UQtZh1G6IW03PITSHLsYxyNuCOnUuFAAdxFq+vd6NR41HgocdmFHUFdwszP4VOHOgGJfCIRQ09iJ2wzs3idt/0yvbuwYJXWIfWLL2IKVOQhsyYQkEegykJkU8JmVIkRNoorrUNLSnDmt+r3Z1PJIxJ2uOf3H/v0NNjIyyad3XrZ+OfQ5IZr6ubPY+Oe7YBx14Lhy3XUWOAjVpmoBkawqeOhZiY0vTRamFKaKHPjikVYDjY1JeoEiMboDNAlWAvVnIDf8mNWEnx1qS1WPEIN0zVfMaXLBErQ24r1HttV3N7ZCbee8H1fLrasXr4t7+UPaxdmNBhH3hJF7bM5tIuQ78VOKI0vrTMVqTsq1ZIo6fv5rdUFZoI019FyIFvav/8IV99d7R9wunqRgAAAABJRU5ErkJggg==',
        serviceActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAh1BMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUNRyTtJAAAALHRSTlMA3ecz+e7ivqtvBwOedFIM1caMeCsS8urYkmpNLxfMt7OEYqNXSkUoIplbPKNgyhcAAAFnSURBVEjH7dPZcoIwFAZgSFgS9kVQEBCpe8/7P1/VDJrWHCQznV71v0zyzT9zkhi/mAWz2VFL+BUAVL4O2ZtXsjrolARwy1mDRA6AXo33ASKBr1EiYq41SjRrdqJEoyZm8MyHN4dciEScSKdEhL2pKZp1HdjfiH2u102hONvSiGcsTUwigBTLJmaSsoxHtH2cp0F3PVtaMBWrvMouoIK4MD8bQWwNQgSpNEgmSFvNF+0428yaBaztc9rFdo4p81i+8rB8K2wuxBivtt+IZe39/CQDmRRkeP06/sWZEM7OV/5fExUr7KsNBO0wkHyaWAnFSL3EpjVgJLPQa8dID1gYIuIOJamnJosVSpKTmkQEJc5eTfJy4kmqSQBS+u1GHlmlJi48suEn48jlBaUoknHf5Ucxj/CBunjqubjhQizIyKQqsl/eQS7AmCZP70/moCKnHiDNm5d1ekN9a6hCQ94gGyE1/vOH+QI5bZ6m5Agn7wAAAABJRU5ErkJggg==',
      },  
      
      
      //-趣玩 =============================================================
      playSpecialList:[],
      //-趣玩 end =========================================================
      
      //-服务 =============================================================
      serviceSpecialList:[],      
      guildLoading:true,
      guildListData:[],//过滤后数据
      guildListAllData:[],//原数据
      //-过虑器
      guildFilterVisible:false,
      filCatagoryText:'类别',
      filterCatagoryId:0,//选中值
      filterCatagoryIndex:0,//选中索引
      guildFilterCatagoryData:[
        { text: '全部类别' ,id:1, disabled: true },
      ],      
      guildFilterRatingVisible:false,
      filRatingText:'等级',
      filterRatingId:0,//选中值
      filterRatingIndex:0,//选中索引
      guildFilterRatingData:[
        { text: '全部等级' ,id:1, disabled: true },
      ],
      guildFilterAreaVisible:false,
      filAreaText:'区域',
      filterAreaId:0,//选中值
      filterAreaIndex:0,//选中值对应索引(未找到设置Picker造中值的方法，暂使用设置Picker 选中索引)
      guildFilterAreaData:[
        { text: '全部区域' ,id:1, disabled: true },
      ],
      //-服务 end =========================================================
      
      
      
      //转播
       //Image list
        pages:[
       /*   {
       //  html: '<img class="go" src="static/img/index/1-go-v2.png" />',
          html: '<img class="act-1-btn-book fen-up-down" src="static/img/act/1/btn-book.png" /><img class="act-1-cloud" src="static/img/act/1/cloud.png" />',
          style: { 
            'background-image':'url(static/img/index/act-1-2.jpg?v=2)'
            },
          id: 100001,
          newsType: 201,
          },
         
         {
          html: '<img  class="act-2-banner-title" src="static/img/act/2/banner/title.png" /> <img  class="act-2-banner-bh ma-left-right" src="static/img/act/2/banner/bh.png" /> <img id="act2BannerMa" class="act-2-banner-ma fen-up-down" src="static/img/act/2/banner/ma.png?v=2" /> <img  class="act-2-banner-qh ma-right-left" src="static/img/act/2/banner/qh.png" /><img  class="act-2-banner-btn" src="static/img/act/2/btn-show.png" />',
          style: { 
            'background-image':'url(static/img/act/2/banner/bg.jpg)',
          //  'background-repeat':'no-repeat',
           // 'background-size':'103% auto !important',
           // 'background-position':'center top !important',
            },
          id: 100002,
          newsType: 201,
         },*/
         //2019年三月三
         /*{
          html: ' <img class="act-4-banner-swallow fen-up-down" src="static/img/act/4/banner/swallow.png" /> <img class="act-4-banner-boats boats-up-down" src="static/img/act/4/banner/boats.png" /> <img class="act-4-banner-go go-tada" src="static/img/act/4/banner/go.png" />',
          style: { 
            'background-image':'url(static/img/act/4/banner/bg-v2.jpg)'
            },
          id: 100004,
          newsType: 201,
          },*/
         //2019年斗牛
         /*{
          html: ' <img class="act-5-banner-cattle-left act-5-3d" src="static/img/act/5/banner/cattle-left.png" /> <img class="act-5-banner-cattle-right act-5-3d-right" src="static/img/act/5/banner/cattle-right.png" /> <img class="act-5-banner-btn" src="static/img/act/5/banner/btn-show.png" />',
          style: { 
            'background-image':'url(static/img/act/5/banner/bg.jpg)'
            },
          id: 100005,
          newsType: 201,
         },*/
         //2019年文博旅游艺术周
        /* {
          html: '<img class="act-6-banner-ship" id="act6BannerShip" src="static/img/act/6/banner/ship.png"> <img class="act-6-banner-liuzhou act-6-animation-liuzhou" src="static/img/act/6/banner/liuzhou.png">         <img class="act-6-banner-2019 act-6-animation-2019" src="static/img/act/6/banner/2019.png"> <img class="act-6-banner-title act-6-animation-title" src="static/img/act/6/banner/title.png">         <img class="act-6-banner-footer act-6-animation-footer" src="static/img/act/6/banner/footer.png">               <img class="act-6-banner-flower-top act-6-animation-flower-top" src="static/img/act/6/banner/flower-top.png">        <img class="act-6-banner-swallow act-6-animation-swallow" src="static/img/act/6/banner/swallow.png">      <img class="act-6-banner-petals-1 act-6-animation-petals-1" src="static/img/act/6/banner/petals.png?v=2">                <img class="act-6-banner-petals-2 act-6-animation-petals-2" src="static/img/act/6/banner/petals.png?v=2">',
          style: { 
            'background-image':'url(static/img/act/6/banner/bg.jpg)'
            },
          id: 100006,
          newsType: 201,
          },*/
        /* {
          html: '<img  class="act-3-banner-btn-show" src="static/img/act/3/btn-show.png" />',
          style: { 
            'background-image':'url(static/img/act/3/banner.jpg?v=2)'
            },
          id: 100003,
          newsType: 201,
          },*/
         /*  {
          html: '<img class="go" src="static/img/index/1-go-v2.png" />',
          style: { 
            'background-image':'url(static/img/index/1.jpg)'
            },
          id: 0,
          newsType: 201,
          },
          ,*/
        // {
            
        //   html: '<img class="go" src="static/img/index/1-go.png" />',
          
        //     style: {
        //     'background-image':'url(static/img/index/1.jpg)'
        //     },
        //   id: 0,
        //   newsType: 201,
        //  },
          
          // 四季
        /*  
          {
          html: '<img class="go" src="static/img/index/3-go.png" />',
          
            style: {
            'background-image':'url(static/img/index/3.jpg?v=2)'
            },
          id: 0,
          newsType: 201,
          },
          
          {
            html: '<img class="go" src="static/img/index/4-go.png" />',
            style: {
              'background-image':'url(static/img/index/4.jpg)'
            },
          id: 0,
          newsType: 201,
          }
          ,
          {
          html: '<img class="go" src="static/img/index/5-go.png" />',
          
            style: {
            'background-image':'url(static/img/index/5.jpg)'
            },
          id: 0,
          newsType: 201,
          },
          {
            html: '<img class="go" src="static/img/index/6-go.png"/>',
            style: {
            'background-image':'url(static/img/index/6.jpg)'
            },
          id: 0,
          newsType: 201,
          }
          */
         
          // 四季 end

          // 跳转新闻
          // {
          //   html: '<img class="go-20190930" src="static/img/index/20190930-go.png"/>',
          //   style: {
          //   'background-image':'url(static/img/index/20190930.jpg)'
          //   },
          // id: 71818,
          // newsType: 201,
          // }
       /*
          {
            html: '',
            style: {
            'background-image':'url(static/img/index/20200430-2.jpg)'
            },
          id: 100013,
          newsType: 201,
          },
          {
            html: '',
            style: {
            'background-image':'url(static/img/index/20200430.jpg)'
            },
          id: 100013,
          newsType: 201,
          }*/       
          // 旅游产业发展大会（列表）      
         /* {
          html: '',
          style: { 
            'background-image':'url(static/img/banner/20201104105627.jpg)'
            },
          id: 100017,
          newsType: 201,
          },
         
          {
          html: '',
          style: { 
            'background-image':'url(static/img/banner/20210111152651.jpg)'
            },
          id: 100018,
          newsType: 201,
          }, 
         {
          html: '',
          style: { 
           'background-image':'url(static/img/banner/2021092901.jpg)',
           'background-repeat':'no-repeat',
           'background-size':'cover !important',
           'background-position':'center top !important',
            },
          id: 0,
          newsType: 201,
          },*/
         

          {
          html: '',
          style: { 
            'background-image':'url(static/img/banner/20200624171642.jpg)'
            },
          id: 100016,
          newsType: 201,
          },
          {
          html: '',
          style: { 
           'background-image':'url(static/img/banner/20210303090904.jpg)',
           'background-repeat':'no-repeat',
           'background-size':'cover !important',
           'background-position':'center top !important',
            },
          id: 100020,
          newsType: 201,
          },
          //{
          //html: '',
          //style: { 
          // 'background-image':'url(static/img/banner/2021082601.jpg)'
          //  },
          //id: 0,
          //newsType: 201,
          //},
          // {
          // html: '',
          // style: { 
          //   'background-image':'url(static/img/banner/20200907165019.jpg)'
          //   },
          // id: 0,
          // newsType: 201,
          // }
          /*,   
          {
          html: '<img class="act-15-line" src="static/img/act/15/line.png" />',
          style: { 
            'background-image':'url(static/img/act/15/bg.jpg)'
            },
          id: 100015,
          newsType: 201,
          }*/
         /* ,
           {
            html: '',
            style: {
            'background-image':'url(static/img/index/100014/1.jpg)'
            },
          id: 100014,
          newsType: 201,
          },{
            html: '',
            style: {
            'background-image':'url(static/img/index/100014/2.jpg)'
            },
          id: 100014,
          newsType: 201,
          },{
            html: '',
            style: {
            'background-image':'url(static/img/index/100014/3.jpg)'
            },
          id: 100014,
          newsType: 201,
          }*/
          // ,
          // {
          //   html: '',
          //   style: {
          //   'background-image':'url(static/img/index/20200326-1.jpg)'
          //   },
          // id: 78257,
          // newsType: 201,
          // },
          // {
          //   html: '',
          //   style: {
          //   'background-image':'url(static/img/index/20200326-go.jpg)'
          //   },
          // id: 78257,
          // newsType: 201,
          // }

          // 跳转新闻 end
          /*
          {
            html: '',
            style: {
            'background-image':'url(static/img/act/11/index.jpg)'
            },
          id: 100011,
          newsType: 201,
          },*/
        ],
        //Sliding configuration [obj]
        sliderOptions: {
          currentPage: 0,//当前页码
    	    autoplay:5000,//自动滚动[ms]
    	    loop:true,//循环滚动
    	    slidesToScroll:1,//每次滑动项数
          effect:'fade',
        },
        activeColor:"#222633",
        //鲜料
        newComponentsShow:false,
        titleHeight:'55px',
        navIconHeight:'0', 
        searchHeight:'0',
        newClass:{
        	activeHeight:'0',
        },
        payClass:{
        	activeHeight:'0'
        },
        iframeHeight:'0',
        conentsLoading:true,
        serviceClass:{
        	activeHeight:'0',
        	helperHeight:'0',
        	guildHeight:'0',
        	hotelHeight:'0',
        	trafficHeight:'0',
        	//trafficSrc:'http://m.amap.com/',   
        	trafficSrc:'',      	
	   		weatherHeight:'0',
	   		//weatherSrc:'http://m.lzgd.com.cn/inc/lzgd/tweb/tq.html',
	   		weatherSrc:'',
	   		lexiangHeight:'0',
	   		lexiangSrc:'',
        },
        interval:null,
        backPosition:0,
      /* 新料快报 */
      list: [{
      	id:1,
      	title:'柳州市',
      	tel:'0772-3171883'
      }],
       hotelListData:[],
     
      loading: false,      
      finished: true,
      newsBaoClass:{
      	newbaoListHeight:'212px',
      },
      LngLat:'',      
      Act4DialogHeight:0,
    }
  }, 
  watch:{
    'DialogList.TrafficDialog.visible': {
      deep: false,
      handler: function (newVal,oldVal){
        let vm = this
        if(!newVal){
          setTimeout(function(){
            vm.serviceClass.trafficSrc = ""
          },200)
        } 
      }      
    },
    'DialogList.MapsDialog.visible': {
      deep: false,
      handler: function (newVal,oldVal){        
        let vm = this
        if(!newVal){
          this.c("watch->DialogList.MapsDialog.visible","隐藏地图iframe")
          this.showMaps = false          
        } 
      }      
    },
    'active': {
      deep: false,
      handler: function (newVal,oldVal){
        let vm = this
        if(newVal == 10){
          
        } 
      }      
    },
    'DialogList.ArticleDialog.visible':{
      deep: true,
      handler: function (newVal,oldVal){
        let vm = this
        if(newVal){           
        /* vm.news = {
            id:0,
            sid:0,
            cid:0,
            title:'',
            contents:'',     
            categoryName:'',
            thumbnail:'',
            addTime:'',
            visits:0, 
            address:'',
            tel:'',        
            copyright:'',
            ad:'',
            latlng:'',
          }*/
        } else {  
          vm.news = {
            id:0,
            sid:0,
            cid:0,
            title:'',
            contents:'',     
            categoryName:'',
            thumbnail:'',
            addTime:'',
            visits:0, 
            address:'',
            tel:'',        
            copyright:'',
            ad:'',
            latlng:'',
          }    
        } 
      }  
    },
    'ExerciseDialog.visible': {
      deep: true,
      handler: function (newVal,oldVal){
        let vm = this
        if(newVal){
          //显示遮罩层
          this.oneLevelModalMaskVisible = true           
         
        } else {
          this.oneLevelModalMaskVisible = false    
      } 
      }      
    },
    
    'ExerciseListDialog.visible': {
      deep: true,
      handler: function (newVal,oldVal){
        let vm = this
        if(newVal){
          //显示遮罩层
          this.oneLevelModalMaskVisible = true           
         
        } else {
          //this.oneLevelModalMaskVisible = false         
      } 
      }
      
    },    
    //-TOP榜 ====================         
    'DialogList.SearchDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal !=0 && newVal !='0' || newVal != '0px'){
                _czc.push(['_trackEvent', '《TOP榜》板块', '点击', '轮播图图标','4','0']);
               }
            }
      }, 
    //-TOP榜  end ================     
    //-VR  ================      
    'DialogList.VrDialog.y': {
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal == 'translateY(-100%)'){                                          
                 this.vrSrc = ''
               }
            }
      }, 
    //-鲜料  ================      
    'DialogList.NewMenuDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){ 
               if(newVal != 0 && newVal != '0' && newVal != '0px'){              
                 _czc.push(['_trackEvent', '《鲜料》板块', '点击', '导航栏','0','0']);
               }
            }
      }, 
      'DialogList.NewsListDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){                                          
                 _czc.push(['_trackEvent', '《鲜料》板块', '点击', '城事精选','0','1'])             
               }
            }
      },  
      'DialogList.ToutiaoListDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){  
                 _czc.push(['_trackEvent', '《鲜料》板块', '点击', '闲游头条','0','2'])             
               }
            }
      },   
      'DialogList.RenyimenListDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){       
              if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){  
                _czc.push(['_trackEvent', '《鲜料》板块', '点击', '乡旅动态','0','3'])             
              }
            }
      }, 
    //-鲜料 end  ================    
    
    //-智图  ============
    'DialogList.MapsDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){              
              if(newVal != 0 && newVal != '0' && newVal != '0px'){
                _czc.push(['_trackEvent', '《智图》板块', '点击', '导航栏','1','0']);
              }
            }
      },
    //-智图  end ========    
    
    //-趣玩  ================    
    'DialogList.PlayMenuDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal != 0 && newVal != '0' && newVal != '0px'){
                 _czc.push(['_trackEvent', '《趣玩》板块', '点击', '导航栏','2','0']);
               }
            }
      }, 
      'DialogList.QuancunMenuDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
              if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){              
                _czc.push(['_trackEvent', '《趣玩》板块', '点击', '全村第一站','2','1'])             
              }
            }
      },   
      'DialogList.GonglvMenuDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){
               if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){  
                 _czc.push(['_trackEvent', '《趣玩》板块', '点击', '趣玩攻略','2','2'])             
               }
            }
      },    
      'DialogList.CanyuMenuDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){              
                 _czc.push(['_trackEvent', '《趣玩》板块', '点击', '互动活动','2','3'])             
               }
            }
      },  
      'DialogList.ExerciseMenuDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
              if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){    
                _czc.push(['_trackEvent', '《趣玩》板块', '点击', '体验师推荐','2','4'])            
              }
            }
      }, 
      'DialogList.ActListDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){     
               if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){       
                 _czc.push(['_trackEvent', '《趣玩》板块', '点击', '趣玩正当时','2','5'])             
               }
            }
      },  
    //-趣玩  end ============
    
    //-服务  ========
    'DialogList.ServiceDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){
               if(newVal != 0 && newVal != '0' && newVal != '0px'){
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '导航栏','3','0']);
               }
            }
      },
    'DialogList.TrafficDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){
              let vm = this
               if(newVal==0 || newVal=='0' || newVal == '0px'){
                  setTimeout(function(){
                    vm.serviceClass.trafficSrc = ''
                  },200)
               } else{
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '趣玩交通','3','1']);
               }
            }
      },
    'DialogList.WeatherDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){
              let vm = this
               if(newVal==0 || newVal=='0' || newVal == '0px'){
                  setTimeout(function(){
                    vm.serviceClass.weatherSrc = ''
                  },200)
               }else{
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '闲游天气','3','2']);
               }
            }
      },      
      'DialogList.HotelDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
              if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){  
                _czc.push(['_trackEvent', '《服务》板块', '点击', '酒店民宿','3','3'])             
              }
            }
      },      
      'DialogList.FoodDialog.y':{
            deep: true,
            handler: function (newVal,oldVal){              
               if(newVal == 'translateY(0)' || newVal == 'translateY(0px)' ){  
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '柳味美食','3','4'])             
               }
            }
      },  
    'DialogList.GuildDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){
              let vm = this
               if(newVal == 0 || newVal == '0' || newVal == '0px'){
                  setTimeout(function(){
                    vm.guildListData = []
                    vm.filterAreaId = 0
                    vm.filAreaText = '区域'
                    vm.filRatingText = '等级'
                    vm.filterRatingId = 0
                    vm.filterCatagoryId = 0
                    vm.filCatagoryText = '类别'
                  },200)
               }else{
                  vm.guildListData = vm.guildListAllData                  
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '旅行社','3','5']);
             
               }
            }
      },          
    'DialogList.HelperDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){
              if(newVal != 0 && newVal != '0' && newVal != '0px'){
                  this.guildListData = this.guildListAllData                  
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '联系我们','3','6']);
             
               }
            }
      },    
    'DialogList.LexiangDialog.height': {
            deep: true,
            handler: function (newVal,oldVal){
              let vm = this
               if(newVal == 0 || newVal == '0' || newVal == '0px'){
                  setTimeout(function(){
                    vm.serviceClass.lexiangSrc = ''
                  },200)
               }else{
                 _czc.push(['_trackEvent', '《服务》板块', '点击', '乐享柳州','3','7']);
               }
            }
      },
      //-服务 end ========
      '$route' (to, from) { 
        this.c('to',to)
        this.c('from',from)

        if(this.getDialogTopLevel() == 0){
          console.log("1",window.location.href);
          if( from && from.fullPath != '/'){
            this.setDocument('乡村闲游', '','','')
          }else{
            console.log("window.history.go(-1)")
            for(var i =  window.history.length;i> 0;i--){
              try{
                window.history.go(-1 * i);
              }catch(e){

              }
            }
          }
         
        
        } else if(to.query.view){


        let newTo = {stateKey:window.history.state.key,query:to.query,fullPath:to.fullPath,meta:to.meta}
        this.routeHistory.push(newTo)        
      this.c('','前一页 from = ' , from)
      this.c('','准备进入的页面是  to = view:' + to.query.view)
      this.c('','准备进入的页面是  to = type:' + to.query.type)
      this.c('','准备进入的页面是  to = newsid:' + to.query.newsid)
      this.c('to',to)

        let view =parseInt(to.query.view);
        let type =parseInt(to.query.type);
        switch(view){
          case 1://鲜料
            if(to.query.view && !to.query.type){
              document.title = "鲜料"
            } else  if(to.query.type && !to.query.newsid){
              if(type==1){
                document.title = "城事精选"
              } else if(type==2){
                document.title = "闲游头条"
              } else if(type==3){
                document.title = "乡旅动态"
              }else if(type==4){
                document.title = "村长甄选"
              }
            }
          break;
          case 2://智图
            if(to.query.view && !to.query.type){
              document.title = "智图"
            } else  if(to.query.type && !to.query.newsid){
              if(type==1){
                document.title = "智图"
              }
            }
          break;
          case 3://趣玩
            if(to.query.view && !to.query.type){
              document.title = "趣玩"
            } else  if(to.query.type && !to.query.newsid){
              if(type==1){
                document.title = "全村第一站"
              } else if(type==2){
                document.title = "趣玩攻略"
              } else if(type==3){
                document.title = "互动活动"
              }else if(type==4){
                document.title = "村长甄选"
              }
            }
          break;
          case 4://服务
            if(to.query.view && !to.query.type){
              document.title = "服务"
            } else  if(to.query.type && !to.query.newsid){
              if(type==1){
                document.title = "趣玩交通"
              } else if(type==2){
                document.title = "闲游天气"
              } else if(type==3){
                document.title = "酒店民宿"
              }else if(type==4){
                document.title = "柳味美食"
              }else if(type==5){
                document.title = "旅行社"
              }else if(type==6){
                document.title = "联系我们"
              }else if(type==7){
                document.title = "村长甄选"
              }
            }
          break;
      }
    }
     
       
     
      }
},
  mounted() {    
    console.log("index","mounted")
    var u = navigator.userAgent, app = navigator.appVersion;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    
    if(!this.isiOS && 1==2) {
      this.debugInfo = "is iOS";
      let aabbcc = this
      document.body.addEventListener('touchmove', function(e) {
        var st = JSON.stringify(e);　
        aabbcc.debugInfo =  e  + " </br>" + aabbcc.debugInfo;
        return;
        aabbcc.debugInfo =  " touchmove </br>" + aabbcc.debugInfo;
        let isScroll = false
        aabbcc.debugInfo =  " touchmove </br>" + aabbcc.debugInfo;
        try{
          for(var i = 0;i<e.path.length;i++){
            console.log(e.path[i].id);
            aabbcc.debugInfo = i + " </br>" + aabbcc.debugInfo;
            if(e.path[i].id == 'clickMe'){
            console.log('-----------finded');
              aabbcc.debugInfo =  " finded clickMe </br>" + aabbcc.debugInfo;
              isScroll = true
            }
          }
          aabbcc.debugInfo =  " isScroll: " + isScroll + " </br>" + aabbcc.debugInfo;
          if(!isScroll){
            e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
          }
        }catch(e){
          aabbcc.debugInfo =  e + " </br>" + aabbcc.debugInfo;
        }
      }, {
        passive: false
      }); //passive 参数不能省略，用来兼容ios和android    
    }

let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
let elementWith = (w * 0.1826);
if(w >= 750) {
  elementWith = 137;
  w = 750;
}

this.Act4DialogHeight = w * 1.778666666666667;

this.titleHeight = elementWith +'px';
  	this.maxHeight = h - elementWith +'px'
  	this.navIconHeight =(elementWith*0.3764) +'px'; 
  	this.newsBaoClass.newbaoListHeight=(w*0.2826) +'px'; //新料快报列表高度
  	let vm =this; 
  	window.onresize = function temp() { 
	  	let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	  	let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	  	let elementWith = (w*0.1826);
	  	if(w>=750){
  		elementWith = 137;
  		w= 750;
  	}
      vm.titleHeight = elementWith +'px'
      vm.maxHeight = h - elementWith +'px'
  		vm.navIconHeight =(elementWith*0.3764) +'px'; 
  		vm.newsBaoClass.newbaoListHeight=(w*0.2826) +'px'; //新料快报列表高度
  	
  	vm.Act4DialogHeight = w * 1.778666666666667;
  		
  //专题2
  try{
  let act2title = ((w * 0.86 * 0.845) + h * 0.03)
  act2title = act2title - act2title *  0.2208201892744479
  let act2maWidth = (h - act2title) * 1.025991792065663
    let act2maLeft = (w - act2maWidth)  / 2
  document.getElementById("act2BannerMa").style["width"] = act2maWidth + 'px'
  document.getElementById("act2BannerMa").style["left"] = act2maLeft + 'px'
    }catch(e){
    
  }
   //专题3
  

vm.actt3Contents1BeginHeight = w * 0.4146666666666667 * 0.6809646302250804+ 'px'
   vm.actt3Contents1Height = w * 0.4146666666666667 * 0.6809646302250804+ 'px'
   vm.actt3Contents1EndHeight  = w * 0.4146666666666667 + 'px'
    
   vm.actt3Contents3BeginHeight = w * 0.5106666666666667 * 0.5639686684073107+ 'px'
   vm.actt3Contents3Height = w * 0.5106666666666667 * 0.5639686684073107  + 'px'   
   vm.actt3Contents3EndHeight  = w * 0.5106666666666667 + 'px'
   
   
    };    
     //专题3
   
    
    // 通过$refs获取dom元素
  let box = this.$refs.articleBox
  
  //专题2
  try{
  let act2title = ((w * 0.86 * 0.845) + h * 0.03)
  act2title = act2title - act2title *  0.2208201892744479
  let act2maWidth = (h - act2title) * 1.025991792065663
  let act2maLeft = (w - act2maWidth)  / 2
  document.getElementById("act2BannerMa").style["width"] = act2maWidth + 'px'
  document.getElementById("act2BannerMa").style["left"] = act2maLeft + 'px'
  }catch(e){
    
  }
  
  
  
  // 监听这个dom的scroll事件
  box.addEventListener('scroll', () => {
    this.c(''," scroll " + this.$refs.articleBox.scrollTop)
    //以下是我自己的需求，向下滚动的时候显示“我是有底线的（类似支付宝）”
    //this.isScroll=this.$refs.articleBox.scrollTop>0
    
    if(this.$refs.articleBox.scrollTop>666){
     this.backtotopVisible = true
   }else{
     this.backtotopVisible = false
   }
    
  }, false)
    
    //-监听返回
    window.addEventListener("popstate",this.windowPopstate);
   
 







vm.actt3Contents1BeginHeight = w * 0.4146666666666667 * 0.6809646302250804+ 'px'
   vm.actt3Contents1Height = w * 0.4146666666666667 * 0.6809646302250804+ 'px'
   vm.actt3Contents1EndHeight  = w * 0.4146666666666667 + 'px'
    
   vm.actt3Contents3BeginHeight = w * 0.5106666666666667 * 0.5639686684073107+ 'px'
   vm.actt3Contents3Height = w * 0.5106666666666667 * 0.5639686684073107  + 'px'   
   vm.actt3Contents3EndHeight  = w * 0.5106666666666667 + 'px'
   
   vm.act3Swiper1 = new Swiper('.act-3-swiper-1', {
          autoplay:true,
          loop:true,
        })
   vm.act3Swiper2 = new Swiper('.act-3-swiper-2', {
          autoplay:true,
          loop:true,
        })
  
   vm.act3Swiper3 = new Swiper('.act-3-swiper-3', {
          autoplay:true,
          loop:true,
        })



 
    //轮播图延迟滚动    
    vm.$refs.slider.$emit('autoplayStop');    
    setTimeout(function(){ 
      try{
        vm.$refs.slider.$emit('autoplayStart',6000);  
      }catch(e){

      }
    },5000)  
    //音频组件
    this.musicPlayerTop = '-97px'
    this.musicPlayerRight = '2px'
  },
  destroyed(){    
    this.c("destroyed","cancel popstate")
    window.removeEventListener("popstate", this.windowPopstate);
},
  created() {
    this.c("index","created")
    this.c("query:",this.$route.query)
    let vm = this
    this.LngLat = this.getQueryVariable("LngLat")
 
   
   
   //this.getAllSpecial()
    setTimeout(function(){      
    // vm.$refs.speciaListMoreRef.getPage()     
    // vm.$refs.playSpeciaListRef.getPage()   
    // vm.$refs.serviceSpeciaListRef.getPage()
    },3000)
  	setTimeout(function(){
  	 
  	 //-加载村长甄选
     //vm.$refs.speciaListMoreRef.newZhenSpecialQuery.zid = 11
     
     
      if(vm.$route.query.view || parseInt(vm.getQueryVariable("view")) ){
        let view =parseInt(vm.$route.query.view) || parseInt(vm.getQueryVariable("view"))
        let type =parseInt(vm.$route.query.type) || parseInt(vm.getQueryVariable("type"))
        let eid =parseInt(vm.$route.query.eid) || parseInt(vm.getQueryVariable("eid"))
        vm.c('',"eid",eid)
        let newsid = 0
        if(vm.$route.query.newsid || parseInt(vm.getQueryVariable("newsid")) ){
          newsid = parseInt(vm.$route.query.newsid) || parseInt(vm.getQueryVariable("newsid"))
        }
        
        if(newsid > 0){
          vm.displayArticle(newsid,0)
          return
        }
        vm.c('',"view",view)
        switch(view){
          case 1://鲜料
            if(type==1){
              vm.handleNew() //城事精选
            } else  if(type==2){
              vm.handleToutiao() //闲游头条
            } else  if(type==3){
              vm.handleRenyimen()//乡旅动态
            } else  if(type==4){
              vm.handleNewZhen() //村长甄选
            } else {
              vm.handleNavNew()
            }
          break;
          case 2:
              //智图
              vm.handleNavMaps()
              break;
          case 3://趣玩
          if(type==1){
              vm.handleQuancun() 
            } else  if(type==2){
              vm.handleGonglv() 
            } else  if(type==3){
              vm.handleCanyu()
            } else  if(type==4){
              vm.handlePlayZhen()
            } else  if(type==5){
              if(eid){
                vm.handleExerciseList(eid);
              }else{
                vm.handleExercise();
              }
            } else  if(type== 6){
              vm.c('',"准备进入'互动活动'")            
              vm.handleAct()
            }else  if(type==7){
              vm.handleEnjoyVR() 
            }else  if(type==8){
              vm.handleYouji() 
            }else {
              vm.handleNavPlay()
            }
          break;
          case 4://服务
          if(type==1){
              vm.displayServiceTraffic() 
            } else  if(type==2){
              vm.displayServiceWeather() 
            } else  if(type==3){
              vm.handleHotel()
            } else  if(type==4){
              vm.handleFood() 
            } else  if(type==5){
              vm.displayServiceGuild() 
            }  else  if(type==6){
              vm.displayServiceHelper() 
            }   else  if(type==7){
              vm.handleServiceZhen() 
            }  else {
              vm.handleNavService()
            }
          break;
          case 5:
            vm.displaySearch();
          break;
        }
      }
  	
  	  //-活动专题  	  
  	  if(vm.$route.query.act || vm.getQueryVariable("act")){
  	    vm.c("created","display-活动专题")
        let act = parseInt(vm.$route.query.act) || parseInt(vm.getQueryVariable("act"))
        let type = parseInt(vm.$route.query.type) || parseInt(vm.getQueryVariable("type"))
        if( act && act!=0 && (!type || type==0 ) ){
          switch(act){
            case 1://闲游宝典                       
              vm.displayAct(act)
              break;
              
            case 2:     
              vm.displayAct(act)
            break;
            
            case 3:     
              vm.displayAct(act)
            break;
            case 4:     
              vm.displayAct(act)
            break;
          }
        }
        if( act && act!=0 && type && type!=0 ){
          switch(type){
          case 1://闲游宝典
            if(type==1){ //市区周边宝典
              vm.displayActList(act,type)
            } else  if(type==2){  //三江宝典
               vm.displayActList(act,type) 
            } else  if(type==3){  //融水宝典
               vm.displayActList(act,type)
            } else  if(type==4){ //鹿寨宝典
              vm.displayActList(act,type)
            } else  if(type==5){ //融安宝典
              vm.displayActList(act,type) 
            } else  if(type==6){ //柳城宝典
              vm.displayActList(act,type) 
            } else  if(type==7){ //柳江区宝典
              vm.displayActList(act,type)
            } 
          break;
          case 2:
            vm.displayAct(2)
          break;
          }
         }
      }
  	  //-活动专题 end
  	  
  	},10);
  	
    if(Cookies.get('keyWord')!=null && Cookies.get('keyWord')!=''){    		
	    	let cookieKeyword = Cookies.get('keyWord');	    	 
	    	let keyword = cookieKeyword.split('W==--==--===W');
	    	for(var i=0;i<=keyword.length;i++){
	    		if(i==5)break;
	    		let w = keyword[keyword.length-i-1];
	    		if(w){
            
	    		//	this.hisList.push(w);
	    		}
	    	}
	    	
    }
    
      // 增加一个postMessage来监听消息
      window.addEventListener('message', this.postMessageListener)   
      this.isBack = false
      document.body.classList.add('loaded');
      //插入访问统计
       //setTimeout(function() {
        //var cz = document.createElement("script");
        //cz.src = "https://s22.cnzz.com/z_stat.php?id=1274943830&web_id=1274943830";
        //document.getElementById("cnzz").appendChild(cz);
       //},1000);
       setTimeout(function() {
        var cz = document.createElement("script");
        cz.src = "js/baidutongji.js";
        document.getElementById("cnzz").appendChild(cz);
       },1000);
      //移除loading
      this.removeLoader()

      //ACT6
      
        setTimeout(function(){
          try{
            document.getElementById("act6BannerShip").className = 'act-6-banner-ship act-6-animation-ship-line'
      }catch(e){

      }
            setTimeout(function(){
              try{
              document.getElementById("act6BannerShip").className = 'act-6-banner-ship act-6-animation-ship-line act-6-animation-ship'
      }catch(e){

      }
            },3500)
        },1000)


  },
  beforeDestroy(){
    clearInterval(this.interval)
  },
    methods: { 　
      windowPopstate(event){
          let vm = this  
    /*  let route = vm.getHistoryBykey(window.history.state.key)
      vm.c("popstate->route",route)
      vm.c("popstate->$route",vm.$route)*/
      //判断是前进还是后退，后退：返回，直到main
      // vm.c("点击后退",'')
      vm.closeOneLevelModalMask() 
      },
              //监听子框架
        postMessageListener(e){ 
          this.c('',e.data) 
          
          if(e.data.action && e.data.action =='setRouterType'){
            let type = e.data.type
            this.isBack = false
            this.setDocument('智图', '?view=2&type='+type,'','')
          }
          
          if(e.data.view && e.data.view=='maps'){
            if(e.data.type && e.data.type=='closeComment'){
              this.closeComment();
            } else if(e.data.type && e.data.type=='setCommentTotal'){         
              this.commentTotal = e.data.commentTotal           
            } else if(e.data.type && e.data.type=='setMapPosition'){         
              this.latlng = e.data.latlng           
            }  else if(e.data.type && e.data.type=='displayComment'){              
              this.newsId = e.data.newsId
              handleComment();              
            } else if(e.data.type && e.data.type=='displayArticle'){ //显示文章窗口
              this.c('',"postMessageListener","显示地图文章窗口")
              this.newsId = e.data.newsId
              this.displayMapArticle(this.newsId,209)
            }
          } else  if(e.data.view && e.data.view=='article'){            
            if(e.data.type && e.data.type=='displayScroll'){
               this.backtotopVisible = true
            }else if(e.data.type && e.data.type=='hideScroll'){               
               this.backtotopVisible = false
            }else if(e.data.type && e.data.type=='handleScroll'){               
               var scrollTop = document.getElementById("articleWrap").scrollTop;
               this.commentTotal = scrollTop
               if(scrollTop>666){
                  this.backtotopVisible = true
               }else{
                 //this.backtotopVisible = false
               }
            }
          }
        },  
        //获取历史记录
        getHistoryBykey(stateKey){
          for(let key in this.routeHistory){
            if( this.routeHistory[key].stateKey == stateKey ){
              return this.routeHistory[key]
            }
          }
        },
        //停止banner
        stopPlaySlider(){          
          this.$refs.slider.$emit('autoplayStop');
          this.$refs.slider.$emit('autoplayStart', 99999999);
          this.$refs.slider.$emit('slideTo', 0);
        },
        easeInOutQuad(t, b, c, d) {
                  if ((t /= d / 2) < 1) return c / 2 * t * t + b
                  return -c / 2 * (--t * (t - 2) - 1) + b
              },
              scrollTo(id,x,y){
                //document.getElementById("messagesHolder").scrollTop 
                //document.getElementById("messagesHolder").scrollHeight;
                if(document.getElementById(id).scrollTo){
                  document.getElementById(id).scrollTo(x,y)
                }else{
                  document.getElementById(id).scrollTop = y
                }
              },
GetRequest() {
  var url = window.location.href; //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    strs = str.split("&");
    for(var i = 0; i < strs.length; i ++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
},
              //返回顶部
     backToTop(){
    try{
        let vm = this
        var start = document.getElementById("articleWrap").scrollTop    
       
        var i = 0
        this.interval = setInterval(() => {
          var next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
          if (next <= vm.backPosition) {
            this.scrollTo("articleWrap",0, vm.backPosition)
            clearInterval(vm.interval)
          } else {
            this.scrollTo("articleWrap",0, next)
          }
          i++
        }, 16.7)
        }catch(e){
          //alert(e)
        }
    },
    //-=点击轮换页   
    handleSlider(id,type){
      this.c("his.$refs.slider.basicdata",this.$refs.slider.data.currentPage)
      let index = this.$refs.slider.data.currentPage
      try{
        id = this.pages[index].id
        type = this.pages[index].newsType
      }catch(e){ 
        this.$router.push('/act8/main')    
      }
      if( id == 100001 ){ 
        this.displayAct(1)
      } else if( id == 100002 ){ 
        this.displayAct(2)
      } else if( id == 100003 ){ 
        this.displayAct(3)
      } else if( id == 100004 ){ 
        this.displayAct(4)
      } else if( id == 100005 ){  
        this.$router.push('/act5/main')          
      } else if( id == 100006 ){  
        window.location.href= "http://h5.eqxiu.com/ls/5HKMP2SH"         
      } else if( id == 100007 ){  
        this.$router.push('/act7')          
      } else if( id == 100011 ){  
        window.location.href= "https://z.lzgd.com.cn/inliuzhou/2019/youliuzhou/default.aspx"         
      } else if( id == 100013 ){ 
        this.displayAct(13)
      }  else if( id == 100014 ){ 
        this.displayAct(14)
      }  else if( id == 100015 ){ 
        this.displayArticle(80950,type)
      } else if( id == 100016 ){ 
        this.displayArticle(81625,type)
      } else if( id == 100017 ){ 
        this.displayAct(20)
      }  else if( id == 100018 ){ 
        this.displayArticle(87179,type)
      } else if( id == 100019 ){ 
        this.displayArticle(88749,type)
      } else if(id == 100020){
        this.displayArticle(89929,type)
      } else if(id== 100030){
        this.displayArticle(89929,type)
      } else if(id== 100031){
        window.location.href= "https://z.lzgd.com.cn/inliuzhou/2021/2021minsu/index.html"
      } else if ( id != 0 ){
        this.displayArticle(id,type)
      } 
    },
        //遮罩层
        
        
    //-======================= firstLoad   
    
    actListLoad(){
      this.$refs.refActList.getData()
    },
    actEnjoyListLoad(){
      this.$refs.refEnjoyActList.getData()
    },
    newsListLoad(){
      this.c("firstLoad","newsListLoad")
      this.$refs.newsList.firstGetdata(200,8)  
    },
    toutiaoListLoad(){
      this.$refs.toutiaoList.firstGetdata(201,8)
    },
    renyimenListLoad(){
      this.c("firstLoad","renyimenListLoad")
      this.$refs.renyimenList.firstGetdata(202,8)
    },
    foodLoad(){
      this.$refs.foodList.firstGetdata(206,8)  
    },
    actShiquListLoad(){
      this.$refs.actShiquList.getInid(this.act1Data.cid,8, this.act1Data.idArray)  
    },
    quancunListLoad(){
      this.$refs.quancunList.firstGetdata(203,8) 
    },
    youjiListLoad(){
      this.$refs.refsYoujiList.firstGetdata(308,8) 
    },
    gonglvListLoad(){
      this.$refs.gonglvList.firstGetdata(204,8)
    },
    canyuListLoad(){
      this.$refs.canyuList.firstGetdata(205,8)
    },
    hotelListLoad(){
      this.$refs.hotelList.firstGetdata(208,8)
    },
    articleCommentsLoad(){
      this.c("firstLoad","articleCommentsLoad")
      this.$refs.articleComments.loadComment(this.newsId)
    },
     act3MainLoad(){
         
      

    },
     act4MainLoad(){
         
      

    },
    //-======================= firstLoad end
        
        
        
      //-======================= 专题活动
      //专题页
      displayAct(id){
        //显示窗口
        //this.displayActById(id) 
        
       
        
        
        
        if( id==1 ){        
          this.$router.push('/act1')
          /*
          this.setDocument('闲游宝典', '?act=1','','')
          //历史记录
          this.firsthistory.push({title:'闲游宝典',shareurl:'?act=1',desc:'',shareimg:''})
           _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '活动主页面','0','1']);
           */
        } else if ( id == 2){         
          this.$router.push('/act2')
          /*
          this.setDocument('苗族系列坡会群', '?act=2','','')
          //历史记录
          this.firsthistory.push({title:'苗族系列坡会群',shareurl:'?act=2',desc:'',shareimg:''})
          this.twohistory.push({title:'苗族系列坡会群',shareurl:'?act=2',desc:'',shareimg:''})          
          _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '活动主页面','0','2']);
          */
        }else if ( id == 3){       
          this.$router.push('/act3')          
        } else if ( id == 4){          
          this.$router.push('/act4')
        } else if ( id == 5){
          this.$router.push('/act5')
        }else if ( id == 6){
          this.$router.push('/act6')
        }else if ( id == 7){
          this.$router.push('/act7')
        }else if ( id == 9){         
          this.displayArticle(71818,201)
          return ;
        }else if ( id == 10){
          this.$router.push('/act10')
        }  else if ( id == 11){
          window.location.href= "https://z.lzgd.com.cn/inliuzhou/2019/youliuzhou/default.aspx"   
        }  else if ( id == 12){         
          this.displayArticle(78257,201)
          return ;
        } else if ( id == 13){         
           this.$router.push('/act13?type=201&idArray=79601,79597,79596,79590,79511,79508,79431,79346,79261,79260,79091,78961')
          return ;
        } else if ( id == 14){         
           this.$router.push('/act14?type=201&idArray=79431,79861,80281,80282,80284,80285,80287,80289,80290')
          return ;
        }else if ( id == 17){         
           this.$router.push('/act17?type=201&idArray=83287,83292,81648,80730,78216,77988')
          return ;
        }else if ( id == 18){         
           this.$router.push('/act18?type=201&idArray=81645,81585,81587,81368,81316,81279,81275,81192,81193,81194,82053,81280,81198,81050,80792,82951,82887')
          return ;
        }else if ( id == 19){         
           this.$router.push('/act19?type=201&idArray=80730,78216,81274,77740,82157,82545,82325,81799,80576,80697')
          return ;
        }else if ( id == 20){         
           this.$router.push('/act20?type=201&idArray=85383,85384,85385,85389,85390,84817,84298')
          return ;
        }else if( id == 21 ){  
          window.location.href= "https://z.lzgd.com.cn/inliuzhou/2021/zlzgn/index.html"    
          return ;     
        }else if ( id == 22){         
           this.$router.push('/act22?type=201&idArray=88587,88588,88522,88548,88551,88462,88414,88390,88392,88288,88287,88203,88179,88113,88115,88076,88080')
            return ;
            }else if( id == 23 ){
            window.location.href= "https://z.lzgd.com.cn/inliuzhou/2021/2021minsu/index.html"
            return ;
            }
            this.$router.push('/act' + id)




            },
            displayAct2Desc(){
            if(this.actt2DescHeight=='240px'){
            this.actt2DescHeight = "0px"
            this.isActt2DescClass = false
            }else{
            this.actt2DescHeight = "240px"
            this.isActt2DescClass = true
            }
            },
            displayActList(actId,id){
            this.c("displayActList","显示专题列表")
            this.c("id",id)
            let shareimgA = ''
            let cid = 200
            let idArray = ''
            let title = ''
            if( actId==1 ){
            if( id==1 ){
            cid = 200
            title = '市区周边宝典'
            idArray = '63288,63293,62396,63420'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“市区周边宝典”页面','1','1']);
            } else if( id==2 ){
            cid = 200
            title = '三江宝典'
            idArray = '63289,57652,63299'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“三江宝典”页面','2','1']);
            }  else if( id==3 ){
            cid = 200
            title = '融水宝典'
            idArray = '63096,61002,62764,63127,63422,63460'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“融水宝典”页面','3','1']);
            } else if( id==4 ){
            cid = 200
            title = '鹿寨宝典'
            idArray = '62803,62936,61000,62934'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“鹿寨宝典”页面','4','1']);
            } else if( id==5 ){
            cid = 200
            title = '融安宝典'
            idArray = '63130,63295,56628'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“融安宝典”页面','5','1']);
            } else if( id==6 ){
            cid = 200
            title = '柳城宝典'
            idArray = '63286,60904,59944,59942'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“柳城宝典”页面','6','1']);
            } else if( id==7 ){
            cid = 200
            title = '柳江区宝典'
            idArray = '63287'
            _czc.push(['_trackEvent', '《2019春节闲游宝典》活动专题', '点击', '“柳江区宝典”页面','7','1']);
            }
            } else  if( actId==2 ){
            if( id==1 ){
            cid = 200
            title = '整英坡会'
            idArray = '64045'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“整英坡会”页面',id,'2']);
            } else if( id==2 ){
            cid = 200
            title = '平卯坡会'
            idArray = '64049'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“平卯坡会”页面',id,'2']);
            }  else if( id==3 ){
            cid = 200
            title = '整依直坡会'
            idArray = '64057'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“整依直坡会”页面',id,'2']);
            } else if( id==4 ){
            cid = 200
            title = '整堆坡会'
            idArray = '64056'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“整堆坡会”页面',id,'2']);
            } else if( id==5 ){
            cid = 200
            title = '安太坡会'
            idArray = '64055'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“安太坡会”页面',id,'2']);
            } else if( id==6 ){
            cid = 200
            title = '古龙坡会'
            idArray = '64046'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“古龙坡会”页面',id,'2']);
            } else if( id==7 ){
            cid = 200
            title = '安陲芒嵩坡会'
            idArray = '64053'
            _czc.push(['_trackEvent', '苗族系列坡会群', '点击', '“安陲芒嵩坡会”页面',id,'2']);
            }
            //三月三，去撒欢
            }else if( actId == 4 ){
            shareimgA = 'https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/4/share.jpg?v=2'
            if( id==1 ){
            cid = 200
            title = '融水宝典'
            idArray = '65171,65166,65294'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“融水宝典”页面',id,actId]);
            } else if( id == 2 ){
            cid = 200
            title = '三江宝典'
            idArray = '65170,65058'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“三江宝典”页面',id,actId]);
            }  else if( id == 3 ){
            cid = 200
            title = '融安宝典'
            idArray = '65205,65292'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“融安宝典”页面',id,actId]);
            } else if( id == 5 ){
            cid = 200
            title = '柳州市区'
            idArray = '65172,65063,65287,65164,65163,65162,65148,65289,65053'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“柳州市区”页面',id,actId]);
            } else if( id == 7 ){
            // idArray = '65298,65299,65062,65300'
            cid = 200
            title = '鹿寨宝典'
            idArray = '65298,65299,65062,65300'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“鹿寨宝典”页面',id,actId]);
            }
            }

            if( !this.firstActshiquListLoad ) this.firstActshiquListLoad = true
            //显示窗口
            this.DialogList.Act1NewsListDialog.show();
            this.DialogList.Act1NewsListDialog.level =  ( this.getDialogTopLevel() + 1 )
            //打开遮罩
            this.openModalMask()

            this.act1Data.cid = cid
            this.act1Data.type = id
            this.act1Data.idArray = idArray
            //url
            this.isBack = false
            this.setDocument(title, '?act='+actId+'&type='+id,'',shareimgA)
          //历史记录
          this.twohistory.push({title:title,shareurl:'?act='+actId+'&type='+id,desc:'',shareimg:shareimgA})  
          this.c("子组件加载数据","")
          //子组件加载数据
         
          let vm = this
          setTimeout(function(){
            vm.$refs.actShiquList.getInid(cid,8,idArray)    
          },400)
         
      },
      //-======================= 专题活动 end
        
        
      
      //-======================= 鲜料        
      //点击[鲜料快报]  
      handleNew(){      
        if(!this.firstNewsLoad)this.firstNewsLoad=true
        let cid = 200         
        this.DialogList.NewsListDialog.show();        
        this.DialogList.NewsListDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('城事精选', '?view=1&type=1','','')
        //历史记录
        this.twohistory.push({title:'城事精选',shareurl:'?view=1&type=1',desc:'',shareimg:''})           
        //子组件加载数据
        /*
        let vm = this
        setTimeout(function(){
          vm.$refs.newsList.firstGetdata(cid,8)                  
        },400)
        */
      },
      //点击[闲游头条]
      handleToutiao(){
        if(!this.firstToutiaoLoad) this.firstToutiaoLoad = true
        let cid = 201  
        this.DialogList.ToutiaoListDialog.show();
        this.DialogList.ToutiaoListDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('闲游头条', '?view=1&type=2','','')
        //历史记录
        this.twohistory.push({title:'闲游头条',shareurl:'?view=1&type=2',desc:'',shareimg:''})     
        //子组件加载数据   
        /*
        let vm = this
        setTimeout(function(){
         vm.$refs.toutiaoList.firstGetdata(cid,8)
        })
        */
      },
      //点击[乡旅动态]
      handleRenyimen(){ 
        if(!this.firstRenyimenLoad)this.firstRenyimenLoad = true
        let cid = 202
                
        this.DialogList.RenyimenListDialog.show();
        this.DialogList.RenyimenListDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('乡旅动态', '?view=1&type=3','','')
        //历史记录
        this.twohistory.push({title:'乡旅动态',shareurl:'?view=1&type=3',desc:'',shareimg:''})     
        //子组件加载数据   
        /*
        let vm = this
        setTimeout(function(){
          vm.$refs.renyimenList.firstGetdata(cid,8)
        },400)
        */
      },
      //点击[村长甄选]
      handleNewZhen(){
        let zid = 11
        //显示窗口
        this.newZhenListVisible = true
        this.isBack = false
        this.setDocument('村长甄选', '?view=1&type=4','','')
        this.twohistory.push({title:'村长甄选',shareurl:'?view=1&type=4',desc:'',shareimg:''})
        //显示遮罩层
        this.oneLevelModalMaskVisible = true
           let vm = this
           setTimeout(function(){
              vm.newZhenListY = 'translateY(0)'  
              vm.newZhenListOpacity = 1
              //vm.oneLevelModalMaskOpacity = 0.6
              vm.oneLevelModalMaskOpacity = 0
           },50);  
        //子组件加载数据
        this.$refs.newZhenList.newsZid = zid
        this.$refs.newZhenList.getData(1001)
      },
      //-======================= 鲜料 end
      
      
      //-======================= 趣玩
      
      //点击[达人游记]
      handleYouji(){
        if( !this.firstYoujiLoad ) this.firstYoujiLoad = true
        let cid = 203
        this.c("handleYouji","点击[达人游记]")
        
        this.DialogList.YoujiMenuDialog.show();
        this.DialogList.YoujiMenuDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('达人游记', '?view=3&type=8','','')
        //历史记录
        this.twohistory.push({title:'达人游记',shareurl:'?view=3&type=8',desc:'',shareimg:''})  
        //子组件加载数据 
      },
      //点击[全村第一站]
      handleQuancun(){
        if( !this.firstQuancunLoad ) this.firstQuancunLoad = true
        let cid = 203
        this.c("handleQuancun","点击[全村第一站]")
        
        this.DialogList.QuancunMenuDialog.show();
        this.DialogList.QuancunMenuDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('全村第一站', '?view=3&type=1','','')
        //历史记录
        this.twohistory.push({title:'全村第一站',shareurl:'?view=3&type=1',desc:'',shareimg:''})  
        //子组件加载数据 
        /*
        let vm = this
        setTimeout(function(){
          vm.$refs.quancunList.firstGetdata(cid,8)  
        },400)
        */
      },
      //点击[趣玩攻略]
      handleGonglv(){
        this.stopPlaySlider()
        if( !this.firstGonglvLoad ) this.firstGonglvLoad = true
        this.c("handleGonglv","点击[趣玩攻略]")
        let cid = 204
         
        this.DialogList.GonglvMenuDialog.show();
        this.DialogList.GonglvMenuDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('趣玩攻略', '?view=3&type=2','','')
        //历史记录
        this.twohistory.push({title:'趣玩攻略',shareurl:'?view=3&type=2',desc:'',shareimg:''})
        //子组件加载数据       
        /*
        let vm = this
        setTimeout(function(){          
          vm.$refs.gonglvList.firstGetdata(cid,8)
        },400)
        */
         
      },
      //点击[互动活动]
      handleCanyu(){
        if( !this.firstCanyuLoad ) this.firstCanyuLoad = true
        this.c("handleCanyu","点击[互动活动]")
        let cid = 205
        
        
        this.DialogList.CanyuMenuDialog.show();
        this.DialogList.CanyuMenuDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('互动活动', '?view=3&type=3','','')
        //历史记录
        this.twohistory.push({title:'互动活动',shareurl:'?view=3&type=3',desc:'',shareimg:''})
        //子组件加载数据   
        /*
        let vm = this
        setTimeout(function(){
          vm.$refs.canyuList.firstGetdata(cid,8)  
        },400)
        */
      },
      //点击[体验师推荐]
      handleExercise(){
        this.c("handleExercise","点击[体验师推荐]")
        let cid = 205
        //显示窗口
        
        this.DialogList.ExerciseMenuDialog.show();
        this.DialogList.ExerciseMenuDialog.level =  ( this.getDialogTopLevel() + 1 )  
          //打开遮罩
        this.openModalMask()
        
        //this.c("ExerciseDialog",this.ExerciseDialog)
        this.isBack = false
        //this.setDocument('体验师推荐', '?view=3&type=5','','')  
        //this.twohistory.push({title:'体验师推荐',shareurl:'?view=3&type=5',desc:'',shareimg:''})
       
        //子组件加载数据
        //this.$refs.experList.getData()
      },
      //点击关闭[体验师推荐]
      closeExercise(){
        //显示窗口
        this.closeOneLevelModalMask()
      },
      //点击[体验师]
      handleExerciseList(id){
        this.c("handleExercise","点击[体验师]") 
        //显示窗口
        this.ExerciseListDialog.show()
        this.isBack = false
        this.setDocument('体验师', '?view=3&type=5&eid='+id,'','')  
       
        //子组件加载数据
        let vm = this
        setTimeout(function(){
          vm.$refs.experArticlesList.listQuery.pageIndex = 1
          vm.$refs.experArticlesList.list = []
          vm.$refs.experArticlesList.eid = id
          vm.$refs.experArticlesList.getData(id)          
        },400)
      },
      
      
      
      //点击[VR赏全景]
      handleEnjoyVR(){
        if(!this.firstActLoad) this.firstActLoad = true

        this.c("handleAct","点击[VR赏全景]")        
        //显示窗口  
        this.DialogList.EnjoyActListDialog.show();
        this.c("this.DialogList.ActListDialog.level",this.DialogList.EnjoyActListDialog.level)  
        this.DialogList.EnjoyActListDialog.level =  ( this.getDialogTopLevel() + 1 ) 
        this.c("this.DialogList.ActListDialog.level",this.DialogList.EnjoyActListDialog.level)     
        //打开遮罩
        this.openModalMask()
        //url
        this.isBack = false
        this.setDocument('VR赏全景', '?view=3&type=7','','')  
        this.twohistory.push({title:'VR赏全景',shareurl:'?view=3&type=7',desc:'',shareimg:''})       
        //子组件加载数据
        let vm = this
        setTimeout(function(){
          //vm.$refs.refActList.getData()  
        },400)
        
      },
      //点击[专题回顾]
      handleAct(){
        if(!this.firstActLoad) this.firstActLoad = true
         
        
        this.c("handleAct","点击[专题回顾]")        
        //显示窗口  
        this.DialogList.ActListDialog.show();
        this.c("this.DialogList.ActListDialog.level",this.DialogList.ActListDialog.level)  
        this.DialogList.ActListDialog.level =  ( this.getDialogTopLevel() + 1 ) 
        this.c("this.DialogList.ActListDialog.level",this.DialogList.ActListDialog.level)     
        //打开遮罩
        this.openModalMask()
        //url
        this.isBack = false
        this.setDocument('专题回顾', '?view=3&type=6','','')  
        this.twohistory.push({title:'专题回顾',shareurl:'?view=3&type=6',desc:'',shareimg:''})       
        //子组件加载数据
        let vm = this
        setTimeout(function(){
          //vm.$refs.refActList.getData()  
        },400)
        
      },
      //打开遮罩
      openModalMask(level){
        this.c("openModalMask","level:"+level)        
        let vm = this
        
        if( this.getDialogTopLevel() > 0){
          this.c("openModalMask","打开遮罩")
          this.oneLevelModalMaskVisible = true          
           setTimeout(function(){
              vm.oneLevelModalMaskOpacity = 0
           },50); 
        }
      },
      
      
      
      
      
      //点击[村长甄选]
      handlePlayZhen(){
        this.c("handlePlayZhen","点击[村长甄选]")
        let zid = 12
        //显示窗口
        this.playZhenListVisible = true
        this.isBack = false
        this.setDocument('村长甄选', '?view=3&type=4','','')
        this.twohistory.push({title:'村长甄选',shareurl:'?view=3&type=4',desc:'',shareimg:''})
        //显示遮罩层
        this.oneLevelModalMaskVisible = true
           let vm = this
           setTimeout(function(){
              vm.playZhenListY = 'translateY(0)'  
              vm.playZhenListOpacity = 1
              //vm.oneLevelModalMaskOpacity = 0.6
              vm.oneLevelModalMaskOpacity = 0
           },50);  
        //子组件加载数据
        this.$refs.playZhenList.newsZid = zid
        this.$refs.playZhenList.getData(1003)
      },
      //-======================= 趣玩 end
      
      
      //-======================= 服务      
      //点击[酒店民宿]
      handleHotel(){
        if( !this.firstHotelLoad ) this.firstHotelLoad = true
        this.c("handleHotel","点击[酒店民宿]")
        let cid = 208
        
        
        this.DialogList.HotelDialog.show();
        this.DialogList.HotelDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
          this.setDocument('酒店民宿', '?view=4&type=3','','')
        //历史记录
          this.twohistory.push({title:'酒店民宿',shareurl:'?view=4&type=3',desc:'',shareimg:''})    
        //子组件加载数据        
        /*
        let vm = this
        setTimeout(function(){
          vm.$refs.hotelList.firstGetdata(cid,8)  
        },400)
        */
      },
      //点击[柳味美食]
      handleFood(){
        if( !this.firstFoodLoad ) this.firstFoodLoad = true
        this.c("handleFood","点击[柳味美食]")
        let cid = 206 
        this.DialogList.FoodDialog.show();
        this.DialogList.FoodDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
          this.setDocument('柳味美食', '?view=4&type=4','','')
        //历史记录
          this.twohistory.push({title:'柳味美食',shareurl:'?view=4&type=4',desc:'',shareimg:''})   
        //子组件加载数据        
        /*
        let vm = this
        setTimeout(function(){
          vm.$refs.foodList.firstGetdata(cid,8)  
        },400)
        */
      },
      //点击[村长甄选]
      handleServiceZhen(){
        let zid = 13
        //显示窗口
        this.serviceZhenListVisible = true
          this.isBack = false
          this.setDocument('村长甄选', '?view=4&type=7','','')
          this.twohistory.push({title:'村长甄选',shareurl:'?view=4&type=7',desc:'',shareimg:''})
        //显示遮罩层
        this.oneLevelModalMaskVisible = true
           let vm = this
           setTimeout(function(){
              vm.serviceZhenListY = 'translateY(0)'  
              vm.serviceZhenListOpacity = 1
              //vm.oneLevelModalMaskOpacity = 0.6
              vm.oneLevelModalMaskOpacity = 0
           },50);  
        //子组件加载数据
        this.$refs.serviceZhenList.newsZid = zid
        this.$refs.serviceZhenList.getData(1004)
      },
      //-======================= 服务 end 
      
      
      
      
      
      
      
      
      
      //关闭一级遮罩层
      closeOneLevelModalMask(){
        // let hasp = window.location.href.split("#");
        // if(hasp.length>1 && hasp[1].indexOf("=")===-1){
        //   // return true;
        // }

        console.log("top-level",this.getDialogTopLevel())
        if(this.getDialogTopLevel() == 0){
          
        console.log("top-level-return",this.getDialogTopLevel())
          return true;
        }
        // 关闭子组件发出的窗口
        // 获取最高层级
        let allDialogTopLive = this.getAllDialogTopLevel()
        for(let key in this.AllDialog){
          if( !this.AllDialog[key].isHide() && this.AllDialog[key].level == allDialogTopLive){
            this.AllDialog[key].hide()
            console.log("关闭子组件发出的窗口 return")
            return;
          }
        }
        // 关闭子组件发出的窗口 end



        if(this.getDialogTopLevel() == 0){
          return;
        }
        this.c("closeOneLevelModalMask","关闭一级遮罩层")
         let vm = this
         
        //关闭最高层
        let topLive = this.getDialogTopLevel()
        let closedSetDocument = false
        for(let key in this.DialogList){
          if( this.DialogList[key].level == topLive){
            this.DialogList[key].hide()
            closedSetDocument = this.DialogList[key].closedSetDocument
          }
        }
        topLive = this.getDialogTopLevel()
        this.c("closeOneLevelModalMask->topLive",topLive)
        if(topLive <= 1){
          this.oneLevelModalMaskVisible = false
        }
        this.c("closeOneLevelModalMask->closedSetDocument",closedSetDocument)
        //设置标题
        if(closedSetDocument){
          let title = ''      
          topLive = 0
          let path = ''
          for(let key in this.DialogList){
            if( this.DialogList[key].level > topLive && !this.DialogList[key].isHide() && this.DialogList[key].closedSetDocument){           
              title = this.DialogList[key].name
              path = this.DialogList[key].path
              topLive = topLive
              this.c("title",title)
              if( this.isiOS && path == '?act=4' ){
                
                this.isAct4Scroll = false
             let vm  = this
             setTimeout(function(){
               vm.isAct4Scroll = true
             },700)
             
                     //解决IOS无法滚动bug     
              if(document.getElementById('clickMe').scrollTop == 0){      
                   
                  document.getElementById('clickMe').click()
                document.getElementById('clickMe').scrollTop = 1;
                setTimeout(function(){
                  document.getElementById('clickMe').click()
                  document.getElementById('clickMe').scrollTop = 2;
                  setTimeout(function(){
                    document.getElementById('clickMe').click()
                    document.getElementById('clickMe').scrollTop = 3;
                    setTimeout(function(){
                      document.getElementById('clickMe').click()
                      document.getElementById('clickMe').scrollTop = 4;
                    },300)
                  },200)
                },50)
              } else {       
                
                  document.getElementById('clickMe').click()
                document.getElementById('clickMe').scrollTop = document.getElementById('clickMe').scrollTop - 1
                setTimeout(function(){
                  document.getElementById('clickMe').click()
                  document.getElementById('clickMe').scrollTop =  document.getElementById('clickMe').scrollTop - 1
                  setTimeout(function(){
                    document.getElementById('clickMe').click()
                    document.getElementById('clickMe').scrollTop =  document.getElementById('clickMe').scrollTop - 1
                    setTimeout(function(){
                      document.getElementById('clickMe').click()
                      document.getElementById('clickMe').scrollTop =  document.getElementById('clickMe').scrollTop - 1
                    },300)
                  },200)
                },50)
              }
                
              
              }
            }
          }
          if(title!= ''){
            this.setDocument(title,path,'','')
          }
        }
      },       
      //显示地图文章
      displayMapArticle(id,type){
        clearTimeout(this.displayArticleTimer)
        this.newsId = id
        this.mapArticleVisible = true
        this.backtotopVisible = false
     
     
        this.DialogList.ArticleDialog.show()
        this.DialogList.ArticleDialog.level = ( this.getDialogTopLevel() + 1 )
        //打开遮罩
        this.openModalMask()        
     
     
        //显示文章窗口
        let vm = this
        
        setTimeout(function() {
          //vm.articleY = 'none'  
          //vm.articleOpacity = 1
          //vm.twoLevelModalMaskOpacity = 0.61
          //vm.twoLevelModalMaskOpacity = 0
        }, 10);     
        setTimeout(function() {
          //vm.articleY = 'none'  
          //vm.articleSrc = vm.HOST + '/View/Article.aspx?id=' + vm.newsId
        }, 50)

        
        //window.location.hash = '/HotelList?type=' + type + "&id=" + id;
      
         
        //加载文章内容        
        this.conentsLoading = true
        this.displayArticleTimer = setTimeout(function() {
          vm.c('显示地图文章',"加载文章内容")
          vm.getNewsById(id)
        },600);
      },
      //显示文章
      displayArticle(id,type){
        this.c("displayArticle","显示文章")
        clearTimeout(this.displayArticleTimer)
        this.newsId = id
        this.mapArticleVisible = false
        this.backtotopVisible = false        
        
        
        //显示文章窗口
        let vm = this
        this.DialogList.ArticleDialog.show()
        this.DialogList.ArticleDialog.level = ( this.getDialogTopLevel() + 1 )
        //打开遮罩
        this.openModalMask()             
        //加载文章内容
        this.conentsLoading = true
        this.displayArticleTimer = setTimeout(function() {
          vm.c('显示文章',"加载文章内容")
          vm.getNewsById(id)
        },650);      
      },
      
          
    //加载数据
    getNewsById(id){
        if(this.newsId != id){return;}
        let vm  = this;
        let view =parseInt(vm.$route.query.view);
        let type =parseInt(this.$route.query.type);  
        let act =parseInt(this.$route.query.act);   
        this.conentsLoading = true
        //Toast('正在加载...');//return;
        let data ={id:id}       
        data = qs.stringify(data);
        request.post(this.HOST+'/Action/NewsAction.aspx?action=getNewsById',data)
      .then(function (res) {
        vm.conentsLoading = false;
        if(res.data.state==1){          
          vm.c("getNewsById->vm.newsId",vm.newsId)
          vm.c("getNewsById->res.data.news.ID",res.data.news.ID)
          vm.c("getNewsById->vm.DialogList.ActListDialog.isHide()",vm.DialogList.ActListDialog.isHide())
          if(vm.newsId != res.data.news.ID || vm.DialogList.ArticleDialog.isHide() ){ return;}
          vm.c("getNewsById2",res.data.news)
          vm.news.id = res.data.news.ID
          vm.news.sid = res.data.news.SID
          vm.news.cid = res.data.news.cid
          vm.news.title = res.data.news.LongTitle
          vm.news.categoryName = res.data.news.categoryName
          vm.news.address = res.data.news.address
          vm.news.tel = res.data.news.tel
          vm.news.star = res.data.news.star
          vm.news.thumbnail = res.data.news.thumbnail
          vm.news.addTime = res.data.news.addTime
          vm.news.visits = res.data.news.visits 
          vm.news.contents = res.data.news.NewsContent
          vm.news.ad = res.data.ad
          vm.news.copyright = res.data.copyright
          vm.commentTotal = res.data.commentTotal
          vm.news.latlng = res.data.news.latlng
          vm.news.vr = res.data.news.vr
          vm.isBack = false
          
          if(act ==2 && (id==64045 || id ==64049 || id == 64057 || id == 64056 || id == 64055 || id == 64046 || id == 64053 )){
            vm.setDocument(vm.news.title, '?act=2&newsid='+vm.news.id,vm.news.categoryName,vm.news.thumbnail)
            }else{
              vm.setDocument(vm.news.title, '?view='+view+'&type='+type+'&newsid='+vm.news.id,vm.news.categoryName,vm.news.thumbnail)
          }
          //返回顶部
         if(document.getElementById("articleWrap").scrollTo){
            document.getElementById("articleWrap").scrollTo(0,0)
          }else{
            document.getElementById("articleWrap").scrollTop = 0
          }
       } else {
          if(vm.newsId != id){return;}
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        vm.loading = false
        vm.c('',response);
      });
        
        
        
      },
       
         
    //加载数据
    getListData(cid){
        if(moment().diff((moment(this.lastLoadTime))) <1000 && this.lastLoadTime !=0 ){    
          this.loading = false    
          this.c('',"太快了")
          return 
        }
        this.c('',"moment().diff((moment(this.lastLoadTime)))",moment().diff((moment(this.lastLoadTime))))
        //this.HOST = 'http://localhost:55214/Server'
        let vm  = this;       
        //Toast('正在加载...');//return;
        let data =this.listQuery;
        data.cid = cid;
        data.zid = this.newsZid; //村长甄选ID        
        data = qs.stringify(data);
        request.post(this.HOST+'/Action/NewsAction.aspx?action=getByCategory',data)
      .then(function (res) {
        vm.lastLoadTime = moment().format('YYYY-MM-DD HH:mm:ss')     
         vm.loading = false     
        if(res.data.state==1){ 
            
          for(var i =0;i<res.data.list.length;i++){
            try{
              vm.list.push(res.data.list[i]);
            }catch(e){
              
            }
          }  
          if(res.data.list.length<=0 || res.data.list.length< vm.listQuery.pageSize){
            if(vm.listQuery.pageIndex > 1){
              vm.listGoneVisible = true
            }            
            vm.finished = true;
          }else{
            vm.listQuery.pageIndex++;
          }
          //vm.list.push(res.data.list);  
          //Toast.clear();
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        vm.loading = false
        vm.lastLoadTime = moment().format('YYYY-MM-DD HH:mm:ss')
        vm.c('',response);
      });
        
        
        
      },
          
          
          
          
          
          
          
          
          
          
          
          
          //点击导航按钮
        handleNavigation(){ 
        
        
        
        this.DialogList.NavigationDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.NavigationDialog.level =  ( this.getDialogTopLevel() + 1 )  
        
        
          let vm = this
          setTimeout(function(){       
            setTimeout(function(){ 
              if(this.MPWEIXIN){
                //vm.LngLat = '24.337666,109.426257'
              }
              vm.navigationSrc = "https://z.lzgd.com.cn/LiuzhouTourism/Server/View/MapNavigate.aspx?endLatLng="+vm.news.latlng+"&lnglat="+vm.LngLat;
            },1000)
          },50)
          
          let view =parseInt(vm.$route.query.view)
          let type =parseInt(vm.$route.query.type)
          let newsid =parseInt(vm.$route.query.newsid)
          this.$router.push('?view='+view+'&type='+type+'&newsid='+newsid+"&t="+Math.random())
        },   
           
        //-点击VR按钮
        handleVr(vrSrc){ 
        this.c("handleVr","点击VR按钮")
        this.DialogList.VrDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.VrDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
       // this.setDocument('乡旅动态', '?view=1&type=3','','')
        //历史记录
     //   this.twohistory.push({title:'乡旅动态',shareurl:'?view=1&type=3',desc:'',shareimg:''})     
       
                        
          let vm = this
          setTimeout(function(){     
            vm.vrSrc = vrSrc
          },1000)
          
        }, 
     //-排行榜  ==========================================================  
    //加载数据
    getTopData(){
        let vm  = this;       
        let data =this.topListQuery;        
        data = qs.stringify(data);
        request.post(this.HOST+'/Action/NewsAction.aspx?action=getTop',data)
      .then(function (res) { 
         vm.searchTopLoading = false     
        if(res.data.state==1){ 
            
          for(var i =0;i<res.data.list.length;i++){
            try{
              vm.searchTopata.push(res.data.list[i]);
            }catch(e){
              
            }
          }   
          if(res.data.list.length<=0 || res.data.list.length< vm.topListQuery.pageSize){
           
             
              vm.searchTopGoneVisible = true
             
          }else{
          
            vm.topListQuery.pageIndex++;
          }
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        vm.searchTopLoading = false 
        vm.c('',response);
      });
        
        
        
      },
     //-排行榜 end ==========================================================
        
            
            
            
     //-文章 end ==========================================================
      
      
 
     //关闭评论
     closeComment(){
       this.c('',"关闭评论")
       this.closeThreeLevelModalMask();
       return;
          //清空数据
           let vm = this
            this.commentY = 'translateY(-100%)'  
            this.commentOpacity = 0
            this.modalMaskOpacity = 0
           setTimeout(function(){
            vm.modalMaskVisible = false
            vm.commentVisible = false
           },500); 
     },
    //点击评论按钮
    handleComment(){
      this.c("handleComment","点击显示评论按钮")
      
      
      this.DialogList.CommentDialog.show()
      this.DialogList.CommentDialog.level =  ( this.getDialogTopLevel() + 1 )

      //子组件加载数据
            
       //let vm = this
      //this.c('',"aaa",this.$refs.articleComments)
      
      if( !this.firstCommentsLoad ){
        this.firstCommentsLoad = true
      }else{
        this.$refs.articleComments.loadComment(this.newsId)
      }
        let view =parseInt(this.$route.query.view)
        let type =parseInt(this.$route.query.type)
        
       this.$router.push('?view='+view+'&type='+type+'&newsid='+this.newsId+"&t="+Math.random())
       
      },
    handleBacktotop(){
       //alert("window.scrollY:"+window.scrollY+"   document.documentElement.scrollTop:"+document.documentElement.scrollTop+"   document.body.scrollTop :"+document.body.scrollTop +"   window.pageYOffset:"+window.pageYOffset)
        
        this.backToTop()
    },
      
 
        
        
      
        //-文章 end ==========================================================
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    	//
  	mapsLoaded(){
  	  this.mapsLoadingVisible = false
      this.showMaps = true;
  	},
		iframeLoaded(){
			this.iframeHeight='100%';
			this.conentsLoading = false;
		},
    	 // Listener event
      slide (data) {
	        if(data.currentPage==1){
	        	//this.activeColor = "#6bb285";
	        } else if(data.currentPage==2){
	        	this.activeColor = "#dd609a";
	        } else if(data.currentPage==3){        	
	        	this.activeColor = "#009143";
	        } else if(data.currentPage==4){        	
	        	this.activeColor = "#b99400";
	        } else if(data.currentPage==5){        	
	        	this.activeColor = "#be0202";
	        }  else{
	        	this.activeColor = "#222633";
	        }
       
      },
      onTap(data) {
        this.c('',"id111111111111:",data)
        this.c('',"id:",id)
        this.displayArticle(id,newsType);
      },
      onInit (data) {
        let vm =  this
        this.c('初始化banner',data)
        
    
      },
      	hideAllComponents(){
  			this.$refs.slider.$emit('autoplayStop');  
			 this.$refs.slider.$emit('autoplayStart',6000);    
      		this.newClass.activeHeight = '0';
      		this.payClass.activeHeight = '0';
      		this.serviceClass.activeHeight = '0';
      		this.serviceClass.helperHeight = '0';
    		this.active = 10;
      	},
      	
      	
    	//显示搜索窗口
    	displaySearch(){
    	  this.firstSearch = true
    		let vm = this
        setTimeout(function(){
          if(vm.searchTopata == null || vm.searchTopata =='' || vm.searchTopata.length<=0){
            vm.getTopData()
          }
           //vm.onSearch()
        },300)
  		 
        this.DialogList.SearchDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.SearchDialog.level =  1
    			    
        //url          
        this.isBack = false
        this.setDocument('搜索', '?view=5&type=1','','')
        //历史记录
        this.twohistory.push({title:'搜索', shareurl: '?view=5&type=1',desc:'',shareimg:''})   
         
    	},
    	
        //-鲜料=============================================================
        
       
        
        
        
        
    	 //获取村长甄选数据
        getAllSpecial(){
          //this.getNewsSpecialPage()
         
          
          let vm  = this
          let data = {cid:0}
          data = qs.stringify(data)
          //this.HOST = 'http://localhost:55214/Server'
          
         
          request.post(this.HOST+'/Action/NewsAction.aspx?action=getAllSpecial',data)
          .then(function (res) {               
            if(res.data.state==1){
              for(var i =0;i<res.data.list.length;i++){
                let zid = res.data.list[i].zid;
                if(zid==11){
                  //vm.newsSpecialList.push(res.data.list[i])
                }else if(zid==12){                  
                  vm.playSpecialList.push(res.data.list[i])
                }else if(zid==13){   
                 if(vm.serviceSpecialList.length<=2){
                    vm.serviceSpecialList.push(res.data.list[i])
                  }
                }
              }
           } else {
              Toast(res.data.msg); 
            }
          })
          .catch(function (response) {
            this.c('',response);
          });
      },
    	//点击鲜料
      handleNavNew() {
    	   let vm  = this    	  
        if(this.DialogList.NewMenuDialog.isHide()) {
          this.closeAllDialog()
          this.DialogList.NewMenuDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');          
          this.DialogList.NewMenuDialog.level = 1
          //url          
          this.isBack = false
          this.setDocument('鲜料', '?view=1','','')
          this.firsthistory.push({title:'鲜料', shareurl:'?view=1',desc:'',shareimg:''})
          //banner
          this.stopPlaySlider()
          
          //nav
          this.activeColor = "#222633";
          this.active = 0;
          
          //加载村长甄选        
          this.c("handleNavNew","加载村长甄选")
           this.$refs.speciaListMoreRef.getFirstPage() 
        } else {
          this.c("handleNavNew","displayMain")
          this.displayMain()
        } 
    	},
    	//-鲜料 end =========================================================      
      displayMain(){ 
        this.c("displayMain","显示banner")
        //
        document.title = '乡村闲游'
        this.isBack = false
        this.setDocument('乡村闲游','','','')
       //隐藏搜索
        this.searchHeight = '0';
         
        //开始滚动大图
        this.$refs.slider.$emit('autoplayStop');
        this.$refs.slider.$emit('autoplayStart', 6000);
        
        this.closeAllDialog()
        //所有导航不激活
        this.active = 10;
      },
      
      //智图
      handleNavMaps(){
        this.c("handleNavMaps","点击导航栏->智图")
        let vm = this
        if(this.DialogList.MapsDialog.isHide()) { 
          this.closeAllDialog()
          this.DialogList.MapsDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');          
          this.DialogList.MapsDialog.level = 1
          //url          
          this.isBack = false
          this.setDocument('智图', '?view=2','','')
          this.firsthistory.push({title:'智图', shareurl:'?view=2',desc:'',shareimg:''})
          setTimeout(function(){
            vm.mapsLoadingVisible = false
          },5000)
          setTimeout(function(){
            vm.showMaps = true
          },500)   
          //banner
          this.stopPlaySlider()
          //nav
          this.activeColor = "#222633";
          this.active = 1;
             
        } else { 
          this.displayMain()
        } 
      },
      
      //-Dialog========
      
      //关闭所有Dialog
      closeAllDialog(){
        for(let key in this.DialogList){
          this.DialogList[key].hide()
        }
      },
       //目前窗口最高
      getDialogTopLevel(){
        let topLive = 0
        for(let key in this.DialogList){
          if( this.DialogList[key].level > topLive && !this.DialogList[key].isHide()){           
            topLive = this.DialogList[key].level
          }
        }
        this.c("目前窗口最高",topLive)
        return topLive
      },
       //显示活动海口
      displayActById(id){
        this.c("displayActById->id:",id)  
        for(let key in this.DialogList){
          if( this.DialogList[key].type == 2 && this.DialogList[key].id == id){
            if( this.DialogList[key].animationType == 1 ){
              this.c("displayActById->setHeight:",this.DialogList[key].animationType)
              this.DialogList[key].setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
            } else if( this.DialogList[key].animationType == 2 ){
              this.c("displayActById->show:",this.DialogList[key].animationType)              
              this.DialogList[key].show()              
            }
            this.DialogList[key].level =  ( this.getDialogTopLevel() + 1 )
            this.c(this.DialogList[key].name + "->leve:",this.DialogList[key].level)
            if(this.isiOS && this.DialogList[key].path=='?act=4'){
             
             this.isAct4Scroll = false
             let vm  = this
             setTimeout(function(){
               vm.isAct4Scroll = true
             },700)
             
             //解决IOS无法滚动bug     
              if(document.getElementById('clickMe').scrollTop == 0){   
                  document.getElementById('clickMe').click()             
                document.getElementById('clickMe').scrollTop = 1;
                setTimeout(function(){
                  document.getElementById('clickMe').click()
                  document.getElementById('clickMe').scrollTop = 2;
                  setTimeout(function(){
                    document.getElementById('clickMe').click()
                    document.getElementById('clickMe').scrollTop = 3;
                    setTimeout(function(){
                      document.getElementById('clickMe').click()
                      document.getElementById('clickMe').scrollTop = 4;
                    },300)
                  },200)
                },50)
              } else {          
                document.getElementById('clickMe').click()      
                document.getElementById('clickMe').scrollTop = document.getElementById('clickMe').scrollTop - 1
                setTimeout(function(){
                  document.getElementById('clickMe').click()
                  document.getElementById('clickMe').scrollTop =  document.getElementById('clickMe').scrollTop - 1
                  setTimeout(function(){
                    document.getElementById('clickMe').click()
                    document.getElementById('clickMe').scrollTop =  document.getElementById('clickMe').scrollTop - 1
                    setTimeout(function(){
                      document.getElementById('clickMe').click()
                      document.getElementById('clickMe').scrollTop =  document.getElementById('clickMe').scrollTop - 1
                    },300)
                  },200)
                },50)
              }
             
             
             
             
             
            }
          }
        }
      },
      //-Dialog end========
      
      //趣玩
      handleNavPlay(){        
        let vm  = this
        if(this.DialogList.PlayMenuDialog.isHide()) {
          this.closeAllDialog()
          this.c("handleNavPlay",'')
          this.DialogList.PlayMenuDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');          
          this.DialogList.PlayMenuDialog.level =  1
          //url          
          this.isBack = false
          this.setDocument('趣玩', '?view=3','','')
          this.firsthistory.push({title:'趣玩', shareurl:'?view=3',desc:'',shareimg:''})
          //banner
          this.stopPlaySlider()
          //nav
          this.activeColor = "#222633";
          this.active = 2;
          
          //加载村长甄选        
          this.c("handleNavPlay","加载村长甄选")
          this.$refs.playSpeciaListRef.getFirstPage()   
        } else {
          this.c("handleNavPlay","displayMain")
          this.displayMain()
        } 
    	},
    	
      
       /* =============================
       * 服务
       * ============================*/
    	
    	//-点击服务================
    	handleNavService() { 
    	  
    	   let vm  = this
        if(this.DialogList.ServiceDialog.isHide()) {
          this.closeAllDialog()
          this.c("this.titleHeight",this.titleHeight)
          this.DialogList.ServiceDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
          this.DialogList.ServiceDialog.level =  1
          //url          
          this.isBack = false
            this.setDocument('服务', '?view=4','','')
            this.firsthistory.push({title:'服务', shareurl:'?view=4',desc:'',shareimg:''})
          //banner
          this.stopPlaySlider()
          //nav
          this.activeColor = "#222633";
          this.active = 3;
          
          //加载村长甄选        
          this.c("handleNavService","加载村长甄选")
          this.$refs.serviceSpeciaListRef.getFirstPage()  
        } else {
          this.displayMain()
        }  

    	},//服务,酒店民宿
    	//显示酒店民宿
    	displayServiceHotel(){
    		 this.c('',"displayServiceHotel");
    		if(this.serviceClass.hotelHeight == '0'){   
	    		this.serviceClass.hotelHeight=  'calc(100%  - '+this.titleHeight+' + 0px)'; 
      			 this.$refs.slider.$emit('autoplayStop');  
      			 this.$refs.slider.$emit('autoplayStart',99999999);
	    	     this.$refs.slider.$emit('slideTo', 0);
	    	     //this.$refs.slider.basicdata.currentPage=0;
	    	     this.activeColor = "#222633";
    			this.active = 3;  
    				document.title = '酒店民宿'			 
    		}else{ 
      			this.$refs.slider.$emit('autoplayStop');  
    			this.$refs.slider.$emit('autoplayStart',6000);    			 
    			this.serviceClass.hotelHeight = '0';    			 
    		}
    	},
    	
    	//服务，乐享
    	displayServiceLexiang(){
        this.DialogList.LexiangDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.LexiangDialog.level =  ( this.getDialogTopLevel() + 1 )  
    		   //打开遮罩
        this.openModalMask() 
        //url          
        this.isBack = false
        this.setDocument('乐享柳州', '?view=4&type=8','','')
        //历史记录
        this.twohistory.push({title:'乐享柳州',shareurl:'?view=4&type=8',desc:'',shareimg:''})
        let vm = this
        setTimeout(function(){  
          vm.serviceClass.lexiangSrc='https://z.lzgd.com.cn/inliuzhou/2018/lexiang/default.aspx'
        },400)
    	},
    	//-点击服务，趣玩交通================
    	displayServiceTraffic(){ 
    	    let vm = this
        	this.serviceClass.trafficSrc='https://m.amap.com/';  
        	 
        this.DialogList.TrafficDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.TrafficDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('趣玩交通', '?view=4&type=1','','')
        //历史记录
        this.twohistory.push({title:'趣玩交通',shareurl:'?view=4&type=1',desc:'',shareimg:''})
    	}, 
    	
      //服务，闲游天气
      displayServiceWeather(){ 
        let vm = this
        this.serviceClass.weatherSrc='https://xw.tianqi.qq.com/';
         
        this.DialogList.WeatherDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.WeatherDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('闲游天气', '?view=4&type=2','','')
        //历史记录
        this.twohistory.push({title:'趣玩交通',shareurl:'?view=4&type=2',desc:'',shareimg:''})
      },
   
    	
    	//服务,联系我们
    	displayServiceHelper(){
        this.DialogList.HelperDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.HelperDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
        this.setDocument('联系我们', '?view=4&type=6','','')
        //历史记录
        this.twohistory.push({title:'联系我们',shareurl:'?view=4&type=6',desc:'',shareimg:''})
        //导航栏
        this.activeColor = "#222633";
        this.active = 3;
    	},
    	
    	
    	
     /* =============================
     * 服务，旅行社 
     * ============================*/
      displayServiceGuild(){
        let vm = this
        
        this.DialogList.GuildDialog.setHeight('calc(100%  - ' + this.titleHeight + ' + 0px)');
        this.DialogList.GuildDialog.level =  ( this.getDialogTopLevel() + 1 )  
        //打开遮罩
        this.openModalMask()
        //url          
        this.isBack = false
          this.setDocument('旅行社', '?view=4&type=5','','')
        //历史记录
        this.twohistory.push({title:'旅行社',shareurl:'?view=4&type=5',desc:'',shareimg:''})     
        //获取数据
        if(this.guildListAllData.length <= 0){
          this.getServiceGuild()
        } 
      },
      //获取向导数据
        getServiceGuild(){ 
          let vm  = this
          let data = {cid:0}
          data = qs.stringify(data)
          //this.HOST = 'http://localhost:55214/Server'
          
         //let h = 'http://z.lzgd.com.cn/LiuzhouTourism/Server'
        // h = 'http://localhost:55214/Server'
          request.post(this.HOST+'/Action/ServiceGuildAction.aspx?action=GetAll',data)
          .then(function (res) {    
            vm.guildLoading = false
            if(res.data.state==1){
              vm.guildListData = res.data.serviceGuildList
              vm.guildListAllData  = res.data.serviceGuildList
              vm.guildFilterCatagoryData = res.data.catagoryList
              let allCatagory = {id:0,name:'全部类别',text:'全部类别'}
              vm.guildFilterCatagoryData.unshift(allCatagory)
              
              vm.guildFilterRatingData = res.data.ratingList
              let allRating = {id:0,name:'全部等级',text:'全部等级'}
              vm.guildFilterRatingData.unshift(allRating)
              
              vm.guildFilterAreaData = res.data.areaList
              let allArea = {id:0,name:'全部区域',text:'全部区域'}              
              vm.guildFilterAreaData.unshift(allArea)
           } else {
              Toast(res.data.msg); 
            }
          })
          .catch(function (response) {
            vm.guildLoading = false
            vm.c('',response);
          });
      },
      
      displayFilCatagory(){
        this.guildFilterVisible = true
      },
      onCancelCatagory(){
        this.guildFilterVisible = false
        this.$refs.filterCatagory.setIndexes([this.filterCatagoryIndex])
      },
      onConfirmCatagory(value, index){
        this.guildFilterVisible = false
        //Toast(`当前值：${value.id}, 当前索引：${index}`)
        this.filCatagoryText = value.text
        this.filterCatagoryId = value.id
        this.filterCatagoryIndex = index
        this.getGuildFilterData()
      },      
      displayFilRating(){
        this.guildFilterRatingVisible = true
      },
      onCancelRating(){
        this.guildFilterRatingVisible = false
        this.$refs.filterRating.setIndexes([this.filterRatingIndex])
      },
      onConfirmRating(value, index){
        this.guildFilterRatingVisible = false
        //Toast(`当前值：${value.id}, 当前索引：${index}`)
        this.filRatingText = value.text
        this.filterRatingId = value.id
        this.filterRatingIndex = index
        this.getGuildFilterData()        
      },  
      displayFilArea(){
        this.guildFilterAreaVisible = true
      },
      onCancelArea(){
        this.guildFilterAreaVisible = false          
        this.$refs.filterArea.setIndexes([this.filterAreaIndex])
      },
      onConfirmArea(value, index){
        this.guildFilterAreaVisible = false
        //Toast(`当前值：${value.id}, 当前索引：${index}`)
        this.filAreaText = value.text
        this.filterAreaId = value.id
        this.filterAreaIndex = index
        this.getGuildFilterData()
      },
      //筛选
      getGuildFilterData(){
        // filterRating filterCatagory
        //this.c('',"this.$refs.filterArea.getColumnValue()",this.$refs.filterArea)        
        //let areaId = this.$refs.filterArea.getValues()[0].id;    
        this.guildLoading = true
        this.guildListData = [] 
        let filterList = []
       // this.c('',"this.guildListAllData",this.guildListAllData)
        for(var i =0;i<this.guildListAllData.length;i++){
          let result = this.guildListAllData[i] 
          let isResult = true //是否一至
          //区域
          if( this.filterAreaId != 0 ){
            if( result.areaId != this.filterAreaId){
              isResult = false
            }
          }
          //等级
          if( this.filterRatingId != 0 ){
            if( result.ratingId != this.filterRatingId){
              isResult = false
            }
          }
          //类别
          if( this.filterCatagoryId != 0 ){
            if( result.catagoryId != this.filterCatagoryId ){
              isResult = false
            }
          }
          if(isResult && result){
            filterList.push(result)
          }
        }
        if( this.filterAreaId == 0 && this.filterRatingId == 0 && this.filterCatagoryId == 0 ){
          filterList = this.guildListAllData
        }       
        let vm  =  this
        setTimeout(function(){
          vm.guildLoading = false
          vm.guildListData = filterList  
        },500)
        
      },
      onLoadGuildData(){
      	
      },
     /* =============================
     * 服务，旅行社 end
     * ============================*/
     
    	
      //服务，酒店民宿
      onLoadHotelData(){
      	
      },
      //服务，酒店民宿 end
    onClickLeft() {
      Toast('返回');
    },
    setKeyWord(value){
    	this.bookFilter.keyWord = value;
    },
    onMoreSearch(type){
      Toast.clear();
      if(this.keyWord == null || this.keyWord == ''){
        Toast('请输入搜索关键字');
        return
      }       
      let vm  = this
      //鲜料
      let data = this.searchNewQuery
    	if(type==1){   //鲜料 	  
    	}else if(type==2){ //智图
        data = this.searchMapsQuery
      }else if(type==3){ //趣玩
        data = this.searchPlayQuery
      }else if(type==4){ //互动活动
        data = this.searchPlayRecruitQuery
      }else if(type==5){ //服务
        data = this.searchServiceQuery
      }
    	data.type = type
      data.keyWord = this.keyWord
      data = qs.stringify(data)        
      Toast('正在搜索...');
      axios.post(this.HOST+'/Action/NewsAction.aspx?action=searchMore',data)
      .then(function (res) {
          vm.loading = false;
        if(res.data.state==1){
         
          //鲜料
          if(type==1){
            for(var i =0;i<res.data.list.length;i++){            
              vm.searchNewData.push(res.data.list[i])           
            }   
            if(res.data.list.length < vm.searchNewQuery.pageSize){
              vm.searchNewMoreVisible = false
            }
            vm.searchNewQuery.pageIndex++
          //智图
          }else if(type==2){
            for(var i =0;i<res.data.list.length;i++){            
              vm.searchMapsData.push(res.data.list[i])           
            }   
            if(res.data.list.length < vm.searchMapsQuery.pageSize){
              vm.searchMapsMoreVisible = false
            }
            vm.searchMapsQuery.pageIndex++ 
            //趣玩
         }else if(type==3){
            for(var i =0;i<res.data.list.length;i++){            
              vm.searchPlayData.push(res.data.list[i])           
            }   
            if(res.data.list.length < vm.searchPlayQuery.pageSize){
              vm.searchPlayMoreVisible = false
            }
            vm.searchPlayQuery.pageIndex++           
             //互动活动
         }else if(type==4){
            for(var i =0;i<res.data.list.length;i++){            
              vm.searchPlayRecruitData.push(res.data.list[i])           
            }   
            if(res.data.list.length < vm.searchPlayRecruitQuery.pageSize){
              vm.searchPlayRecruitMoreVisible = false
            }
            vm.searchPlayRecruitQuery.pageIndex++           
           //服务
         }else if(type==5){
            for(var i =0;i<res.data.list.length;i++){            
              vm.searchServiceData.push(res.data.list[i])           
            }   
            if(res.data.list.length < vm.searchServiceQuery.pageSize){
              vm.searchServiceMoreVisible = false
            }
            vm.searchServiceQuery.pageIndex++           
        }       
          Toast.clear();
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        vm.c('',response);
      });
      
    	
    	
    },
    onSearch(){
      Toast.clear();
      if(this.keyWord == null || this.keyWord == ''){
        Toast('请输入搜索关键字');
        return
      }
      this.firstSearch = false
    	let vm  = this;
  	  let data = this.searchQuery
      data.keyWord = this.keyWord
      data = qs.stringify(data)  
      
    	_czc.push(['_trackEvent', '《TOP榜》板块', '点击', '搜索','4','1']);
    	Toast('正在搜索...');//return;
	    axios.post(this.HOST+'/Action/NewsAction.aspx?action=search',data)
		.then(function (res) {
	  		vm.loading = false;
	    if(res.data.state==1){
	  	  vm.searchNewData = res.data.newList;  
  		  if(res.data.newList.length < vm.searchNewQuery.pageSize){
          vm.searchNewMoreVisible = false
      }	  		
	  		vm.searchMapsData = res.data.mapsList;
	  		  if(res.data.mapsList.length < vm.searchMapsQuery.pageSize){
          vm.searchMapsMoreVisible = false
        }
        
        
        vm.searchPlayData = res.data.playList;
          if(res.data.playList.length < vm.searchPlayQuery.pageSize){
          vm.searchPlayMoreVisible = false
        }
        
        
        vm.searchPlayRecruitData = res.data.playRecruitList;
          if(res.data.playRecruitList.length < vm.searchPlayRecruitQuery.pageSize){
          vm.searchPlayRecruitMoreVisible = false
        }
        
        
	  		vm.searchServiceData = res.data.serviceList;
	  		  if(res.data.serviceList.length < vm.searchServiceQuery.pageSize){
          vm.searchServiceMoreVisible = false
        }
        
        
	  		
	  		Toast.clear();
	   } else {
    		Toast(res.data.msg); 
    	}
	  })
	  .catch(function (response) {
	    vm.c('',response);
	  });
    	
    	
    	
    } 
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
   /*--- 活动专题  ---*/
.atc-components{
  overflow-y: scroll !important;
  background-color: rgba(0,0,0,0.5) !important;
  font-size: 0;
}

/* id-1 */
.act-1-link{
  position: absolute;
  left:9%;
  top: 12%;
  width: 82%;
  height: 15%; 
}
.act-1-link img{
  width: 100%;
  margin-top: 4%;
}
/* id-1 end */


/* id-2 */
.act-2-link {
  position: absolute;
  left: 9%;
  top: 0%;
  width: 82%;
  height: 15%;
}

.act-2-link img {
  width: 100%;
  margin-top: 4%;
}

.act-2-desc {
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}

.act2down {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}

.act2downno {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

.act-2-desc-content::-webkit-scrollbar {
  width: 7px;
  /*滚动条宽度*/
  height: 7px;
  /*滚动条高度*/
}


/*定义滚动条轨道 内阴影+圆角*/

.act-2-desc-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  /*滚动条的背景区域的圆角*/
  background-color: rgba(190, 109, 4, 1);
  /*滚动条的背景颜色*/
}


/*定义滑块 内阴影+圆角*/

.act-2-desc-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #FFFFFF;
  /*滚动条的背景颜色*/
}

/* id-2 end */


 
/* id-3 end */



/*--- 活动专题 end ---*/ 

  /* 搜索排行榜 */
 .search-top-wrap{   
    border-top:0.81rem solid #e8e9eb ;
    background-color: #e8e9eb;
   padding-bottom: 0.81rem;
 }
 .search-top-banner{
   background-color: #e8e9eb;
 }
 .top-list-item{
    border-bottom:0.25rem solid #e8e9eb ;
    background-color: #FFF;
 }
  .search-top-wrap img{
    width: 100%;
  }
  .search-top-wrap .top-img{
    width: 100%;
    height:5rem;
    font-size: 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .search-top-wrap .top-ico{
    width: 8%;
    margin-left: 20px;
  }
  .search-top-wrap .top-title{    
    border:0.25rem solid #FFF ;
    color: #222632;
    font-size: 0.32rem;
    line-height: 0.43rem;
    letter-spacing: 2px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
  .search-top-wrap .top-info{
    border-left:0.25rem solid #FFF ;
    border-right:0.25rem solid #FFF ;
    border-bottom:0.25rem solid #FFF ;
    font-size: 0.26rem;
    color: #8A8A8A;
  }
  .search-top-more{
    text-align: center;
    height: 0.78rem;
    line-height: 0.78rem;
    font-size: 0.26rem;
    color: #8A8A8A;
    background-color: #FFF;
  }
   .list-gone{
  width: 100%;
  text-align: center;
  line-height: 55px;
  height: 55px;
  padding-bottom: 3%;
 }
 /* 搜索排行榜  end*/
 
 
 /* 评论 */

 .comments-total{
    position: absolute;
    top: -37%;
    left: 51%;
    z-index: 2;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
    text-align: center;
    box-sizing: border-box;
    padding: 0 6px;    
    min-width: 28px;
    line-height: 28px;
    border-radius: 16px;
    background-color: rgba(0, 145, 67, 0.8);
 }
  .comments-maps-total{    
    top: 120px;
  }
 
 .comment-components{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 6;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow: hidden;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: opacity 500ms ease,transform 400ms ease;
    transition: opacity 500ms ease,transform 400ms ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 } 
 .comment-close{
       position: absolute;
    bottom: 0;
    right: 0;
    font-size: 28px;
    padding: 15px;
 }
 /* 评论 end*/
  
 
  
  /* 智图 */
.maps-loading {
    width: 100%;
    height: 100%;
    opacity: 1;
    background: transparent;
    z-index: 2;
    background-size: 4px 4px;
    position: absolute;
    left: 0;
    top: 0;
    /*background-image: url(../../static/img/map/p1-s2-bg.jpg);*/
    background-size: contain;
}
.maps-logo{
  z-index: 2;
    position: absolute;
        left: 41%;
    top: 32%;
    width: 20%;
}
.maps-conents-loading{
  width: 10.56%;
    left: 44.54%;
    top: 40.26%;
}
 .btn-navigation{
   position:relative;
   width: 100%;  
 }
 .btn-vr{
   width: 100%;
   position:relative;
 }
 
/* 智图 */
  
  
  
.modal-mask{
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: rgba(0,0,0,0);
  -webkit-transition: opacity 300ms ease;
  transition: opacity 300ms ease;
}
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  /* 鲜料  */
 
 
 
 
 
 
 
 
 
 
 
 
    /* 甄选 */
   .new-list-img{
    position: relative;
    width: 3.31rem;
    height: 2.52rem;
    float: left;
    margin-bottom: 0.179rem;
    background-position: center;
    background-size: 100% 100%;
   }
   .new-list .article-ico{
     width: 36px!important;
     height: auto;
   }
   .new-list-title{
    position: absolute;
    width: 90%;
    height: 0.787rem;
    height: auto;
    left: 5%;
    bottom: 5%;
    color: #FFF;
    font-size: 0.3rem;
    font-weight: bold;
    letter-spacing:2px;
    line-height: 0.40rem;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */   
   }
  /* 鲜料  end*/
  
  
  
  
  
  .search-form-wrap{
    width: 106%!important;
  } 
  
  
  
  
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: inherit;
}
 .slider-wrap{
 	width:100%;
 	height:100%;
 	position: absolute;
 	top:0;
 	left:0; 	
 }
.menu-components{
	position: fixed;
	top:0;
	left:0;
	z-index: 5;
	width: 100%;
	height: 0;
	overflow-x: hidden;
	background-color: #FFF;
	-webkit-transition: top 250ms, height 400ms;
  transition: top 250ms, height 400ms;
  transition-timing-function: ease, ease;
  -webkit-transition-timing-function: ease, ease;  
  /*-webkit-overflow-scrolling:touch;*/  
}
.session{
  -webkit-overflow-scrolling: touch;
}
.menu-maps{ 
  z-index: 3; 
/*
  height: auto !important;
  max-height: 0px;
  -webkit-transition: max-height 400ms !important;
  transition: max-height 400ms !important;
  */
}
 
 
 
 
 
 
.search-tabs{
	margin-top: 15px;
}
.btn-moretype-submit{
	width: 80%;
	height: 35px;
	line-height: 35px;
	margin-bottom: 10px;
	margin-top: 10px;
}
.his-title{
	text-align: left;
	background-color: #e5e5e5;
	color: #4e4e4e;
	padding-left: 20px;
	line-height: 45px;
	font-size: 16px;
}
.btn-clearhis{
    margin-top: 20px;
    padding: 0px 16px;
    height: 28px;
    color: #e70014;
    border: 1px solid #e70014;
}
.btn-lib{
	
	    position: absolute;
    top: 42%;
    left: 13%;
    width: 84%; 
    height: 13%;
}
.btn-sort{
	    position: absolute;
    top: 61%;
    left: 13%;
    width: 84%; 
    height: 13%;
}



/* 服务  */
	.service-helper-collapse{
		border-top: 0.2rem solid #e8e9eb;
	}
	.service-helper-collapse img{
		width: 100%;
	}
	.service-helper-collapse .collapse-icon{
		position: absolute;
		top:27%;
		left: 0.35rem;		
		width: 0.35rem;
	}
	.service-helper-collapse .collapse-title{
		margin-left: 0.7rem;
	}
/* 服务 end */

/* 搜索  */
.search-header{
	height: calc(2.39rem - 0.81rem - 0.81rem);	
	background-color: #e8e9eb;
	padding: 0.81rem 0.35rem 0.03rem 0.35rem;
}
.search-contents{
	overflow-y: scroll;
	-webkit-overflow-scrolling:touch;	
	height: calc(100% - 1.37rem);
	background-color: #e8e9eb;
}
	.search-item-title{
		font-size: 0.34rem;
		line-height: 0.8rem;
		padding-left: 0.35rem;
		background-color: #e8e9eb;
		color: #8A8A8A;
		font-family: SimHei;
	}
	/* 鲜料 */
	.search-new-item{
		position:relative;
		height: 2.21rem;
		background-color: #FFF;
		border-bottom: 0.20rem solid #e8e9eb;
	}
	.search-new-item-left{
		position: absolute;
		top:0;
		left:0;
		width: calc(100% - 2.82rem - 0.35rem - 0.35rem);
		height: calc(100% - 0.25rem - 0.25rem);
		background-color: #FFF;
		padding: 0.25rem 0.35rem;
	}
	.search-new-item-title{
		    font-weight: bold;
    font-size: 0.32rem;
    line-height: 0.43rem;
        letter-spacing: 2px;
    /*height: 0.787rem;*/   
    height: auto;
    color: #222633;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
	}
	.search-new-item-type{
		position: absolute;
		bottom: 0.25rem;
		left: 0.35rem;
		font-size: 0.26rem;
        letter-spacing: 2px;
	}
	.search-new-item-visits{
		position: absolute;
		bottom: 0.25rem;
		right: 0.35rem;
		font-size: 0.26rem;   
		font-family: "黑体","SimHei";  
	}
	.search-new-item-right{
		position: absolute;
		right: 0;
		top:0;
		width: 2.82rem;
		height: 100%;		
		background-color: #FFF;
		background-position: center;
		background-size: auto 100%;
	}
	.result-info{
		position: relative;
		text-align: center;
	    height: 60px;
	    line-height: 0px;
		background-color: #e8e9eb;
	}
	.result-info span{
		 padding: 2px 5px;
	    border-radius: 3px;
	    font-size: 10px;
	    background: #c9c9c9;
	    color: #fff;
	}
	
	
	
	/* 鲜料 end*/
	/* 趣玩*/
	.funnyplay-warp{
	  font-size: 0;
	  background-color: #e8e9eb;
	}
	.funnyplay-warp:after,
	.search-funnyplay-item:after{
             content: ".";
            display: block;
            height: 0;
             clear: both;
             visibility: hidden;
         }
	.search-funnyplay-item{
		display: inline-block;
		width:3.65rem;
		height: calc(4.78rem + 0.2rem);
		border-bottom: 0.2rem solid #e8e9eb;
		background-color: #FFF;
	}
	.search-funnyplay-item:nth-of-type(even){
		width: calc(3.75rem - 0.2rem);
		border-right: 0.2rem solid #e8e9eb;
	}
	.search-funnyplay-item:nth-of-type(odd){
		width: 3.75rem;
	}
	.search-funnyplay-item-img{
	  position: relative;
    width: 100%;
    height: 2.75rem;
    right: 0;
    top: 0;
    background-color: #FFF;
    background-position: center;
    background-size: auto 100%;
	}
	.search-funnyplay-contents{
		position: relative;
		height: calc(100% - 2.75rem - 0.25rem - 0.25rem);
		font-size: 0.32rem;
		padding: 0.25rem 0.35rem;
	}
	.search-funnyplay-title{
		font-size: 0.32rem;   
		 line-height: 0.43rem;
    height: auto;
    font-weight: bold;
        letter-spacing: 2px;
    color: #222633;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
	}
	.search-funnyplay-type{
		position: absolute;
		bottom:0.25rem;
		left:0.35rem;
		font-size: 0.26rem;		
	}
	.search-funnyplay-visits{
		position: absolute;
		bottom:0.25rem;
		right:0.35rem;
		font-size: 0.26rem;		
		font-family: "黑体","SimHei";
	}
	/* 趣玩 end*/
	
	/* 互动活动 */
	.search-recruitfunny-item{
		height: calc(5.59rem + 2.12rem + 0.2rem);
    	border-bottom: 0.2rem solid #e8e9eb;
	}
	.search-recruitfunny-item-left{
		    position: relative;
		    width: 5.27rem;
		    height: 1.89rem;
		    float: left;
	}
	.search-recruitfunny-item-contents {
	    position: relative;
	    font-weight: bold;
	    padding: 0.25rem 0.35rem;
	    height: calc(2.12rem - 0.25rem - 0.25rem);
	    background-color: #FFF;
	}
	.search-recruitfunny-item-title {
		font-size: 0.32rem;
		line-height: 0.43rem;
        letter-spacing: 2px;
	}
	.search-recruitfunny-item-type{
		    position: absolute;
		    bottom: 0.25rem;
		    left: 0;
		    font-size: 0.26rem;
		    color: #8A8A8A;
        letter-spacing: 2px;
	}
	.search-recruitfunny-item-visits{		
		    position: absolute;
		    bottom: 0.25rem;
		    right: 0;
		    font-size: 0.26rem;
		    color: #8A8A8A;
		    font-family: "黑体","SimHei";
		    font-weight: 300;
		    
        
	}
	.search-recruitfunny-item-img{		
   position: relative;
    width: 100%;
    height: 5.59rem;
    right: 0;
    top: 0;
    background-color: #FFF;
    background-position: center;
    background-size: auto 100%;
	}
	.search-recruitfunny-item-go{
		    position: relative;
		    width: 1.515rem;
		    height: calc(2.12rem - 0.25rem - 0.25rem);
		    float: left;
	}
	.search-recruitfunny-item-go img {
	    width: 86.75%;
	    margin-left: 13.25%;
	    margin-top: 13.25%;
	}
	/* 互动活动 end*/
	
	
	
	
	.search-more{
		text-align: center;
		height: 0.78rem;
		line-height: 0.78rem;
		font-size: 0.26rem;
		color: #8A8A8A;
		background-color: #FFF;
	}
/*搜索 end */
</style>
<style>	
  .slider-item{
    background-position: 50%!important;
    background-size: cover!important;
  } 
  
  .slider-item:nth-child(1){
    /*background-size: 100% auto !important;*/
  } 
   
   @media screen and (min-height: 800px) {
    .slider-item:nth-child(1){
      background-position: 0!important;
      background-size: 100% 100% !important;
    }
 }
  
  .van-icon-upgrade::before{
    background-color: #FFF !important;
    border-radius: 14px;
  }
/* 搜索  */ 
.search-header input{
	text-align: center;
	height: 0.78rem;	
	font-size: 0.34rem;
	color: #8A8A8A;
	width: 90%;
	margin-left: 5%;
    border-radius: 0.5rem;
}
.search-header .van-search{
	padding: 0;
}
.search-header .van-search--show-action{
	background-color: inherit !important;
}
.search-header .van-search .van-cell{	
    border-radius: 0.5rem;
    padding:0;
    border: 0.02rem solid #999999;
}
.search-header .van-search .van-icon-search{
	display: none;
	left: auto;
	right: 0.12rem;	
	font-size: 0.34rem;	
	padding: 0.2rem;
}
.search-header .search-icon-2{
	display: block;
	position: absolute;
	left: auto;
	top: 0.85rem;
	right:0.4rem;
	z-index: 2;	
	font-size: 0.34rem;	
	padding: 0.2rem;
}
.search-header .van-search,.search-header .van-cell{
	height: 0.78rem;	
}
.search-header .van-field__icon{
	
	width: 0.5rem;
	font-size: 0.2rem;
	left:0;
}
/*搜索 end */
</style>
	  

	
	

 
	
	
	
	
	
.van-nav-bar .van-icon{
	color: #FFF !important; 
}
.van-tabs--scrollable .van-tab{
	flex: 0 0 20%;
}
.search-wrap .van-search__action div{
	margin-right: 16px;
    padding: 0px 20px;
    background-color: #e70014;
    border-radius: 2px;
    color: #FFF;
    margin-top: 3px;
}
.search-wrap .van-search__input-wrap{
	margin-top: 10px;
	margin-bottom: 6px;
	border:2px solid #e70014;
    border-radius: 2px;
}
.search-wrap .van-tabs__nav--card .van-tab.van-tab--active{
	    background-color: #e70014;
}
.search-wrap  .van-tabs__nav--card{
	border: 1px solid #e5e5e5;
}
.search-wrap  .van-tabs__nav--card .van-tab{
	border-right: 1px solid #e5e5e5;
}
</style>


<!-- 菜单 -->
	<style scoped>
		.title-wrap{
			position: absolute;
			top:0;
			left:0;			 
			width: 100%;
			height: 1.37rem;
		} 
		.content-wrap{
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;			
			-webkit-overflow-scrolling:touch;
		}
		 
		
	.new-menu {
		border-top: 0.2rem solid #e8e9eb;
		padding: 0.275rem 0.35rem 0 0.35rem;
		border-bottom: 0.2rem solid #e8e9eb;
	}
	 .new-menu img{
	 	height: 0.34rem;
	 	width: auto; 
	 } 	
		
	.new-list-wrap{
		/*padding: 0.55rem 0.35rem;*/
		padding: 0.55rem 0.35rem 0 0.35rem;
    background-color: #e70014;
	}	
		
		
		
	.new-title{
		width: 3.28rem;
		margin-top: 0.15rem;
		margin-left: 0.15rem;
	}
	.close-title{
		position: absolute;
	    right: 5%;
	    top: 24%;
	    height: 29.3%;
	    padding: 3%;
	} 
	 
	.new-list-wrap .van-hairline::after,.new-list-wrap .van-hairline--top-bottom::after,.new-menu .van-hairline--top-bottom::after,.new-menu .van-hairline::after,.new-menu[class*=van-hairline]::after{
		border: 0 solid #FFFFFF !important;
	}
	
	/* 鲜料图片列表 */
	.new-list{
		margin: 0 !important;
	}
	 
	 .new-list>div{		
			width: 3.31rem;
			height: 2.52rem;
			display: inline-block;
			margin-bottom: -0.06rem;
		} 
		
	.new-list>div:nth-child(odd){	
	 	margin-right: 0.179rem;
		} 
		
	.new-list img{
		max-width: 100%;
	 	width: 100%;
	 	height: 100%;
	}	
	/* 鲜料图片列表 end*/
	
		 
	 
	 
	 
	.index-logo{
		z-index: 2;
	 	position: absolute;
	 	left: 25px;
	 	top:25px;
 		width: 20%;
 		max-width: 160px;
	}
	.index-search{
		z-index: 2;
	 	position: absolute;
	 	right: 10px;
	 	top:17px;
 		width: 16%;
 		padding: 17px;
    max-width: 160px;
	}
	 
	.list-title {
	 	height: 0.34rem !important;/*53%!important;*/	  
	 	width: auto;
	}
	
	.newbao-list-wrap{
		height: calc(100%  - 83px - 10px + 1px);
		overflow-y: auto;
		overflow-x: hidden;
		margin-bottom: 100px;
		border-top: 0.18rem solid #e8e9eb;	
	}
	.newbao-list-img{
		position: absolute;
		width: 2.85rem;
		height: 100%;
		right: 0;
		top:0;
	}
	.newbao-list-title{
		position: absolute;
		top:0;
		left:0;
		width:  4.11rem;
		height: calc(1.58rem - 0.09rem);
		margin: 0.27rem;
	}
	.newbao-list-top{
		font-weight: bold;
		font-size: 0.34rem;		
		line-height: 0.352rem;
		height: 0.68rem;
		/*将height设置为line-height的整数倍，防止超出的文字露出*/
		color: #222633;
		text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-
	 
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */

	}
	.newbao-list-bottom{
		position: absolute;
		bottom:0;
		left:0;
		width: 100%;
		font-size: 0.26rem;	
		color: #8A8A8A;	
	}
	.newbao-list-bottom span:nth-child(1){
	 
	}
	.newbao-list-bottom span:nth-child(2){
		position: absolute;
		right:0;
		top:0;
	}
	
  /*-============= 当地先导 ===============- */
  .guild-filter{
    height: 38px;
    line-height: 38px;
    font-size: 0;
    position: relative;
    border-top: 0.2rem solid #e8e9eb;
    background-color:  #FFF;
  }
  .guild-filter ul li{
    display: inline-block;
    width: 29%;
    margin: 0 2%;
    font-family: "AdobeHeitiStd Regular";
    font-size: 0.29rem;
    color: #222633;
    text-align: center; 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
  }
  .guild-filter-down{
    transform:rotate(0deg) translateX(0px);
    -webkit-transform: rotate(0deg) translateX(0px);
    display: inline-block;
   width: 10%;
   margin-left: 5px;
    vertical-align: middle;
  -webkit-transition: 250ms;
    transition: 250ms;
        transition-timing-function:  ease;
    -webkit-transition-timing-function:  ease; 
  }
  .guild-filter-downed{
    transform: rotate(180deg) translateX(2px);
    -webkit-transform: rotate(180deg) translateX(2px);
  }
  .service-guild .van-list{
    /*height: calc( 100% - 1.37rem );*/
    height: 100%;
    overflow-y: scroll;
    
  }
  /*-============= 当地先导 end ===============- */
</style>
<style>
  
/*  粉   */

.fen {
  pointer-events: auto;
  -webkit-user-select: auto;
}

@-webkit-keyframes frames-up-down {
  0% {
    -webkit-transform: translateY(-10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(-10px));
    -moz-transform-origin: top center;
    transform: translateY(-10px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(10px);
    -moz-transform-origin: top center;
    transform: translateY(10px);
    transform-origin: top center;
  }
}

@keyframes frames-up-down {
  0% {
    -webkit-transform: translateY(-10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(-10px));
    -moz-transform-origin: top center;
    transform: translateY(-10px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(10px);
    -moz-transform-origin: top center;
    transform: translateY(10px);
    transform-origin: top center;
  }
}

.fen-up-down {
  -webkit-animation: frames-up-down 2000ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 2000ms ease-in-out alternate infinite;
  animation: frames-up-down 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}


.boats-up-down {
  -webkit-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation-delay: 260ms;
  -webkit-animation-delay: 260ms;
}

.go-up-down {
  -webkit-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation-delay: 260ms;
  -webkit-animation-delay: 260ms;
}

/*  粉   end */


  .conents-loading{
    position: fixed !important;
    z-index: 4 !important;
    }
   .article-components .van-loading--white {
    padding: 10px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .5);
    margin: auto;
    margin-top: 55%;
    margin-left: 43%;
}
  .search-form-wrap .van-icon-clear{
        right: 16%;
  }
  
  .view-main-warp .go{
	 	position: absolute;
	 	right: 27px;
	 	top:38%;
 		width: 65.8%;
 		max-width: 600px;
 }
  .view-main-warp .act-1-cloud{
    position: absolute;
       width: 33%;
    right: -11%;
    top: 34%;
    max-width: 600px;
 }
 
  .view-main-warp .act-15-line{
    position: absolute;
  width: 45%;
    right: 13%;
    top: 10%;
    max-width: 600px;
 }
 
  .view-main-warp .act-1-btn-book{
    position: absolute;
      width: 15%;
    right: 2px;
    top: 26.5%;
    max-width: 600px;
 }

	.view-main-warp .new-list-wrap .van-cell__value,.new-menu .van-cell{
		font-size: 15px;
		font-weight: bold;
		padding: 0.275rem 0;		
		/*margin-bottom: 0.55rem;*/ 
	}
	 
 
 
	 .view-main-warp .new-list-wrap  .van-col:nth-child(even) {
    /*background-color: #66c6f2;*/
} 
 .view-main-warp .new-list-wrap  .van-col {
    color: #fff;
    font-size: 13px;
    line-height: 30px;
    text-align: center;
    margin-bottom: 10px;
    background-clip: content-box;
}
 .view-main-warp  .new-list-wrap .van-col:nth-child(odd) {
    /*background-color: #39a9ed;*/
}

 
.view-main-warp  .news-list-title .van-cell{
 	padding-top: 0;
 	padding-left: 0;
 	padding-bottom: 0 !important;
 }
 
.view-main-warp .news-list-more{
 height: 0.78rem;
 line-height: 0.9rem;
 width: 100%;
 text-align: center;
 font-size: 0.32rem;
 border-top: 0.2rem solid #e8e9eb;
}
  .view-main-warp .news-list-more-down{
    display: inline-block;
    width: 3.4%;
    margin-left: 5px;
    vertical-align: middle;
    transform:rotate(0deg) translateX(0px);
    -webkit-transform: rotate(0deg) translateX(0px);
    -webkit-transition: 250ms;
    transition: 250ms;
    transition-timing-function:  ease;
    -webkit-transition-timing-function:  ease; 
  }
 
 
 /* 城事精选 */

	.view-main-warp .new-menu .van-cell__value--alone{
		line-height: .0rem !important;
		overflow: visible;
	}
	.view-main-warp .new-list-wrap .van-cell__value--alone{
		padding: 0;	
		line-height: 0rem !important;
	}
	.view-main-warp .newbao-list-wrap .van-cell__value--alone{
		height: calc(2.12rem + 0.09rem);		
	}
	.view-main-warp .newbao-list-wrap .van-cell{
		height: 2.12rem;
		padding: 0;
		border-bottom: 0.09rem solid #e8e9eb;		
	}
	
/* 城事精选 end*/

/* 服务  */
	.service-helper-collapse .van-cell{
		padding: 0;		
		padding-left: 0.35rem;
		border-bottom: 1px solid #e8e9eb;
	}
	
	.service-helper-collapse .van-cell:not(:last-child)::after{
		    border-bottom-width: 0;
	}
	.service-helper-collapse .van-collapse-item{
		border-bottom: 0.2rem solid #e8e9eb;	
	}
	.service-helper-collapse .van-collapse-item__title{
		font-size: 0.34rem;
		height:calc( 0.78rem + 0.2rem );
		line-height:calc( 0.78rem + 0.2rem );
	}
	.service-helper-collapse .van-icon-arrow:before{
		margin-top: 0.25rem;
	}
	.service-helper-collapse .van-cell__right-icon{
		margin-right: 0.35rem;
		font-size: 0.34rem;
	}
	
	/*-============= 当地先导 ===============- */
 
	.service-guild .van-cell {
		width: 100%;
		/*height: calc(2.12rem + 0.2rem);*/
		height: auto;
		padding: 0;
		border-top: 0.2rem solid #e8e9eb;
		float: left;
	}  
	.service-guild .van-list >div:nth-last-child(2){
	  margin-bottom: 1.37rem;
    border-bottom: 0.2rem solid #e8e9eb;
	}
	.service-guild .guild-list-content {
		position: relative;
		font-weight: bold;
		font-family: 'MyriadPro Regular';
		font-size: 0.32rem;
		color: #222633;
		padding: 0.25rem 0.35rem;		
		height:  calc(2.12rem - 0.25rem - 0.25rem);
		
		line-height: 0.42rem;
		/*将height设置为line-height的整数倍，防止超出的文字露出*/
		/*text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;*/
	}
	.service-guild .guild-list-content>div:nth-child(1) {
		position: relative;
		width: 5.27rem;
		
		/*height: calc(2.12rem - 0.25rem - 0.25rem);*/
		float: left;
	}
	.service-guild .guild-list-content>div:nth-child(2) {
		position: relative;
		width: 1.515rem;
		height: calc(2.12rem - 0.25rem - 0.25rem); 
		float: left;
	}
.service-guild .guild-list-content>div:nth-child(2) img {
		width: 86.75%;
		margin-left: 13.25%;
		margin-top: 13.25%;
	}
	
	.service-guild  .content-address{
	  
	}
.service-guild .guild-list-bottom {
		position: absolute;
		bottom: 0;
		width: 100%;
    font-family:'MyriadPro Regular', "黑体","SimHei";
    font-weight: 300;
		font-size: 0.26rem;
		color: #8A8A8A;
    line-height: 0.26rem;
		margin-bottom: 0;
		
	}
	
	.service-guild .guild-list-bottom span:nth-child(1) {
		 
	}
	.guild-result-info{
	   text-align: center;
	}
  /*-============= 当地先导 end ============- */
	
	
	
	
	
	
	
	
	/* 酒店民宿 */
	.service-hotel .van-cell {
		width: 100%;
		height: calc(0 + 2.12rem + 0.2rem);
		padding: 0;
		border-top: 0.2rem solid #e8e9eb;
		float: left;
	}   
	
	/* 酒店民宿 */
	
	
	.iframe-wrap .van-loading--white{
    padding: 10px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .5);
    margin: auto;
    margin-top: 35%;
} 
/* 服务 end */

 
 
 
 .van-picker__cancel, .van-picker__confirm,.van-picker__title{
   font-size: 0.3rem;
 }
</style>

<style>  
  
.act-3-banner-btn-show{
  position: absolute;
  top: 42%;
  left: 4%;
  width: 12%;
  height: auto;
}
.act-2-banner-btn{
  position: absolute;
  top: 62%; 
  width: 12%;
  height: auto;
  right: 10px;
}

.act-2-banner-title{
  position: absolute;
  top: 3%;
  left: 7%;
  width: 86%;
}


.act-2-banner-bh{
  position: absolute;
  bottom: 7%;
  left: -2.5%;
  width: 105%;
}
.act-2-banner-ma{
  position: absolute;
  bottom: -2%;
  left: -15%;
  width: 120%;
}
.act-2-banner-qh{
  position: absolute;
  bottom: 7%;
  left: -2.5%;
  width: 105%;
}


@media screen and (max-width: 320px) {
  .act-2-banner-title{
    position: absolute;
    top: 3%;
    left: 7%;
    width: 86%;
  }
}
@media screen and (max-width: 320px) and (max-height: 480px) {
  .act-2-banner-title{
    z-index: 2;
  }
}
@media screen and (max-width: 375px) and (max-height: 812px) {
 .act-2-banner-ma{
  
  }
}


/*  粉   */

.ma {
  pointer-events: auto;
  -webkit-user-select: auto;
}

@-webkit-keyframes ma-frames-left-right {
  0% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px));
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px);
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
}

@keyframes ma-frames-left-right {
  0% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px));
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px);
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
}

.ma-left-right {
  -webkit-animation: ma-frames-left-right 2000ms ease-in-out alternate infinite;
  -moz-animation: ma-frames-left-right 2000ms ease-in-out alternate infinite;
  animation: ma-frames-left-right 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}



@-webkit-keyframes ma-frames-right-left {
  0% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px));
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px);
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
}

@keyframes ma-frames-right-left {
  0% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px));
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px);
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
}

.ma-right-left {
  -webkit-animation: ma-frames-right-left 2000ms ease-in-out alternate infinite;
  -moz-animation: ma-frames-right-left 2000ms ease-in-out alternate infinite;
  animation: ma-frames-right-left 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}

/*  粉   end */





/* id-4 */

.act-4-banner-go{
 position: absolute;
    width: 12%;
    left: 61%;
    top: 42%;
}

.act-4-banner-boats{
  position: absolute;
      bottom: 1.2rem;
    left: 31%;
    width: 24%;
    
}
.act-4-banner-swallow{
    position: absolute;
    width: 48%;
    left: 13%;
    top: 29%;
}

@-webkit-keyframes tada {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes tada {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.go-tada {
  
  -webkit-animation: tada 2000ms ease-in-out alternate infinite;
  -moz-animation: tada 2000ms ease-in-out alternate infinite;
  animation: tada 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms; 
}


/* id-4 end */


/* id-5 */

.act-5-banner-btn{
  position: absolute;
  width: 10%;
  right: 4%;
  top: 58%;
}
.act-5-banner-cattle-left{
  position: absolute;
  bottom: 1.5rem;
  /*left: -43.4%;*/
  left: -110%;
  width: 98%;
  max-width:100%;
}
.act-5-banner-cattle-right{
  position: absolute;
  bottom: 1.5rem;
  /*right: -52.4%;*/
  right: -110%;
  width: 110%;
  max-width:110%;
}
 

@-webkit-keyframes act-5-animation {
  
  /*0% {
    -webkit-transform: translateX(-110%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-110%);
    -moz-transform-origin: top center;
    transform: translateX(-110%);
    transform-origin: top center;
  }
  1% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  } */
   0% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  } 
 40% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
}

@keyframes act-5-animation {
   0% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  } 
 40% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
}

.act-5-3d {    
  -webkit-animation: act-5-animation 10000ms ease-in-out alternate infinite;
  -moz-animation: act-5-animation 10000ms ease-in-out alternate infinite;
  animation:  act-5-animation 10000ms ease-in-out alternate infinite;
  animation-delay: 560ms;
  -webkit-animation-delay: 560ms; 
  
}



@-webkit-keyframes act-5-animation-right {
0% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  } 
  40% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
}

@keyframes act-5-animation-right {
0% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  } 
  40% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
}

.act-5-3d-right {    
  -webkit-animation: act-5-animation-right 10000ms ease-in-out alternate infinite;
  -moz-animation: act-5-animation-right 10000ms ease-in-out alternate infinite;
  animation:  act-5-animation-right 10000ms ease-in-out alternate infinite;
  animation-delay: 560ms;
  -webkit-animation-delay: 560ms; 
  
}
/* id-5 end */


.debug{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999;
  width: 100%;
  height: 20%;
  overflow-y: scroll;  
  background-color: rgba(0,0,0,0.2);
  font-size: 13px;
  color: red;
}


</style>


 
<!-- act 6 -->
<style > 
.act-6-banner-footer {
  position: absolute;
  width: 92%;
  left: 4%;
  top: 76%;
}
.act-6-banner-flower-top {
  position: absolute;
  width: 60%;
  right: 0;
  top: -15%;
}





.act-6-banner-swallow{  
  position: absolute;
    top: 17%;
    left: -26%;
    width: 14%;
    max-width: 100%;
} 


.act-6-banner-ship{
    position: absolute;
    top: 68%;
    left: -22%;
    width: 14%;
    max-width: 100%;
} 

@-webkit-keyframes act-6-frames-animation-ship {
  0% {
    -webkit-transform:translateY(-130%)  translateX(300%)   rotate(0deg);
    -webkit-transform-origin: center center;
    -moz-transform:translateY(-130%)  translateX(300%)   rotate(0deg);
    -moz-transform-origin: center center;
    transform:translateY(-130%)  translateX(300%)   rotate(0deg);
    transform-origin: center center;
  }
  20% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    transform-origin: center center;
  }
  40% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -moz-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    transform-origin: center center;
  }
  60% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%)  rotate(6deg);
    transform-origin: center center;
  }
  80% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -moz-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    transform-origin: center center;
  }
  100% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    transform-origin: center center;
  }
}

@keyframes act-6-frames-animation-ship {
  0% {
    -webkit-transform:  translateY(-130%)  translateX(300%) rotate(0deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(0deg);
    transform-origin: center center;
  }
  20% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    -webkit-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(6deg);
    transform-origin: center center;
  }
  40% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(-6deg);
    transform-origin: center center;
  }
  60% {
    -webkit-transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    transform-origin: center center;
  }
  80% {
    -webkit-transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    transform: translateY(-130%)  translateX(300%)  rotate(-6deg);
    transform-origin: center center;
  }
  100% {
    -webkit-transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%) rotate(6deg);
    transform-origin: center center;
  }
}

.act-6-animation-ship {
  -webkit-animation: act-6-frames-animation-ship 9s ease-in-out alternate infinite !important;
  animation: act-6-frames-animation-ship 9s ease-in-out alternate infinite !important;
}


@-webkit-keyframes act-6-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes act-6-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.act-6-animation-liuzhou {
  -webkit-animation-name: act-6-fadeIn;
  animation-name: act-6-fadeIn;
  -webkit-animation: act-6-fadeIn 0.5s ease-in-out both;
  -moz-animation: act-6-fadeIn 0.5s ease-in-out both;
  animation: act-6-fadeIn 0.5s ease-in-out both;
  animation-delay: 2600ms;
  -webkit-animation-delay: 2600ms;
}

.act-6-banner-liuzhou{    
    position: absolute;
    top: 13%;
    left: 20%;
    width: 55%;
    max-width: 100%;
} 

 
.act-6-animation-2019 {
  -webkit-animation-name: act-6-fadeIn;
  animation-name: act-6-fadeIn;
  -webkit-animation: act-6-fadeIn 0.5s ease-in-out both;
  -moz-animation: act-6-fadeIn 0.5s ease-in-out both;
  animation: act-6-fadeIn 0.5s ease-in-out both;
  animation-delay: 3000ms;
  -webkit-animation-delay: 3000ms;
}

.act-6-banner-2019{
  position: absolute;
  top: 18%;
  left: 52%;
  width: 26%;
  max-width: 100%;
} 


.act-6-animation-title {
  -webkit-animation-name: act-6-fadeIn;
  animation-name: act-6-fadeIn;
  -webkit-animation: act-6-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-6-fadeIn 0.8s ease-in-out both;
  animation: act-6-fadeIn 0.8s ease-in-out both;
  animation-delay: 3300ms;
  -webkit-animation-delay: 3300ms;
}

.act-6-banner-title{
 position: absolute;
    top: 35%;
    left: 34%;
    width: 31%;
    max-width: 100%;
} 



@keyframes act-6-frames-ship-line {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(-130%)  translateX(300%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(-130%)  translateX(300%);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%);
    transform-origin: center center;
  }
}

.act-6-animation-ship-line {  
  animation-name: act-6-frames-ship-line 3s both;
  -webkit-animation: act-6-frames-ship-line 3s both;
  -moz-animation: act-6-frames-ship-line 3s both;
  animation: act-6-frames-ship-line 3s both;
}

.act-6-animation-footer {
  -webkit-animation: act-6-fadeIn 0.5s ease-in-out both;
  animation: act-6-fadeIn 0.5s ease-in-out both;
  animation-delay: 3800ms;
  -webkit-animation-delay: 3800ms;
}

@keyframes act-6-frames-footer-top {
  0% { 
    opacity: 0;
    -webkit-transform: translateY(0%);
    transform: translateY(0%);
  } 
  100% {
    opacity: 1;    
    -webkit-transform: translateY(85%);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(85%);
    -moz-transform-origin: center center;
    transform:  translateY(85%);
    transform-origin: center center;
  }
}

.act-6-animation-flower-top {  
  animation-name: act-6-frames-footer-top 2s ease-in-out both;
  -webkit-animation: act-6-frames-footer-top 2s ease-in-out both;
  -moz-animation: act-6-frames-footer-top 2s ease-in-out both;
  animation: act-6-frames-footer-top 2s ease-in-out both;
  animation-delay: 3800ms;
  -webkit-animation-delay: 3800ms;
}


@keyframes act-6-frames-swallow {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(-130%)  translateX(300%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(-130%)  translateX(300%);
    -moz-transform-origin: center center;
    transform:  translateY(-130%)  translateX(300%);
    transform-origin: center center;
  }
}

.act-6-animation-swallow {  
  animation-name: act-6-frames-swallow 2s ease-in-out both;
  -webkit-animation: act-6-frames-swallow 2s ease-in-out both;
  -moz-animation: act-6-frames-swallow 2s ease-in-out both;
  animation: act-6-frames-swallow 2s ease-in-out both;
  animation-delay: 4400ms;
  -webkit-animation-delay: 4400ms;
}




.act-6-banner-petals-1{  
    position: absolute;
    width: 100%;
    left: 301%;
    top: -82%;
}
 
.act-6-banner-petals-2{  
    position: absolute;
    width: 80%;
    left: 299%;
    top: -17%;
}


@keyframes act-6-frames-petals-1 {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(330%)  translateX(-300%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(330%)  translateX(-300%);
    -moz-transform-origin: center center;
    transform:  translateY(330%)  translateX(-300%);
    transform-origin: center center;
  }
}

.act-6-animation-petals-1 {  
  animation-name: act-6-frames-petals-1 3s linear both;
  -webkit-animation: act-6-frames-petals-1 3s linear both;
  -moz-animation: act-6-frames-petals-1 3s linear both;
  animation: act-6-frames-petals-1 3s linear both;
  animation-delay: 3200ms;
  -webkit-animation-delay: 3200ms;
}


@keyframes act-6-frames-petals-2 {
  0% {
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  }
  100% {
    -webkit-transform: translateY(400%)  translateX(-550%);
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(400%)  translateX(-550%);
    -moz-transform-origin: center center;
    transform:  translateY(400%)  translateX(-550%);
    transform-origin: center center;
  }
}

.act-6-animation-petals-2 {  
  animation-name: act-6-frames-petals-2 1.5s linear both;
  -webkit-animation: act-6-frames-petals-2 1.5s linear both;
  -moz-animation: act-6-frames-petals-2 1.5s linear both;
  animation: act-6-frames-petals-2 1.5s linear both;
  animation-delay: 6000ms;
  -webkit-animation-delay: 6000ms;
}
.view-main-warp .go-20190930{
  position: absolute;
  top: 48%;
  width: 11%;
  right: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue